export const references = [
  { element: 'H', orbital: '1s', be: 14 },
  { element: 'He', orbital: '1s', be: 25 },
  { element: 'Li', orbital: '1s', be: 55 },
  { element: 'Be', orbital: '1s', be: 111 },
  { element: 'B', orbital: '1s', be: 188 },
  { element: 'C', orbital: '1s', be: 284 },
  { element: 'N', orbital: '1s', be: 399 },
  { element: 'O', orbital: '1s', be: 532 },
  { element: 'F', orbital: '1s', be: 686 },
  { element: 'Ne', orbital: '1s', be: 867 },
  { element: 'Na', orbital: '1s', be: 1072 },
  { element: 'O', orbital: '2s', be: 24 },
  { element: 'F', orbital: '2s', be: 31 },
  { element: 'Ne', orbital: '2s', be: 45 },
  { element: 'Na', orbital: '2s', be: 63 },
  { element: 'Mg', orbital: '2s', be: 89 },
  { element: 'Al', orbital: '2s', be: 118 },
  { element: 'Si', orbital: '2s', be: 149 },
  { element: 'P', orbital: '2s', be: 189 },
  { element: 'S', orbital: '2s', be: 229 },
  { element: 'Cl', orbital: '2s', be: 270 },
  { element: 'Ar', orbital: '2s', be: 320 },
  { element: 'K', orbital: '2s', be: 377 },
  { element: 'Ca', orbital: '2s', be: 438 },
  { element: 'Sc', orbital: '2s', be: 500 },
  { element: 'Ti', orbital: '2s', be: 564 },
  { element: 'V', orbital: '2s', be: 628 },
  { element: 'Cr', orbital: '2s', be: 695 },
  { element: 'Mn', orbital: '2s', be: 769 },
  { element: 'Fe', orbital: '2s', be: 846 },
  { element: 'Co', orbital: '2s', be: 926 },
  { element: 'Ni', orbital: '2s', be: 1008 },
  { element: 'Cu', orbital: '2s', be: 1096 },
  { element: 'Zn', orbital: '2s', be: 1194 },
  { element: 'B', orbital: '2p1/2', be: 5 },
  { element: 'C', orbital: '2p1/2', be: 7 },
  { element: 'N', orbital: '2p1/2', be: 9 },
  { element: 'O', orbital: '2p1/2', be: 7 },
  { element: 'F', orbital: '2p1/2', be: 9 },
  { element: 'Ne', orbital: '2p1/2', be: 18 },
  { element: 'Na', orbital: '2p1/2', be: 31 },
  { element: 'Mg', orbital: '2p1/2', be: 52 },
  { element: 'Al', orbital: '2p1/2', be: 74 },
  { element: 'Si', orbital: '2p1/2', be: 100 },
  { element: 'P', orbital: '2p1/2', be: 136 },
  { element: 'S', orbital: '2p1/2', be: 165 },
  { element: 'Cl', orbital: '2p1/2', be: 202 },
  { element: 'Ar', orbital: '2p1/2', be: 247 },
  { element: 'K', orbital: '2p1/2', be: 297 },
  { element: 'Ca', orbital: '2p1/2', be: 350 },
  { element: 'Sc', orbital: '2p1/2', be: 407 },
  { element: 'Ti', orbital: '2p1/2', be: 461 },
  { element: 'V', orbital: '2p1/2', be: 520 },
  { element: 'Cr', orbital: '2p1/2', be: 584 },
  { element: 'Mn', orbital: '2p1/2', be: 652 },
  { element: 'Fe', orbital: '2p1/2', be: 723 },
  { element: 'Co', orbital: '2p1/2', be: 794 },
  { element: 'Ni', orbital: '2p1/2', be: 872 },
  { element: 'Cu', orbital: '2p1/2', be: 951 },
  { element: 'Zn', orbital: '2p1/2', be: 1044 },
  { element: 'Ga', orbital: '2p1/2', be: 1143 },
  { element: 'Ge', orbital: '2p1/2', be: 1249 },
  { element: 'B', orbital: '2p3/2', be: 5 },
  { element: 'C', orbital: '2p3/2', be: 7 },
  { element: 'N', orbital: '2p3/2', be: 9 },
  { element: 'O', orbital: '2p3/2', be: 7 },
  { element: 'F', orbital: '2p3/2', be: 9 },
  { element: 'Ne', orbital: '2p3/2', be: 18 },
  { element: 'Na', orbital: '2p3/2', be: 31 },
  { element: 'Mg', orbital: '2p3/2', be: 52 },
  { element: 'Al', orbital: '2p3/2', be: 73 },
  { element: 'Si', orbital: '2p3/2', be: 99 },
  { element: 'P', orbital: '2p3/2', be: 135 },
  { element: 'S', orbital: '2p3/2', be: 164 },
  { element: 'Cl', orbital: '2p3/2', be: 200 },
  { element: 'Ar', orbital: '2p3/2', be: 245 },
  { element: 'K', orbital: '2p3/2', be: 294 },
  { element: 'Ca', orbital: '2p3/2', be: 347 },
  { element: 'Sc', orbital: '2p3/2', be: 402 },
  { element: 'Ti', orbital: '2p3/2', be: 455 },
  { element: 'V', orbital: '2p3/2', be: 513 },
  { element: 'Cr', orbital: '2p3/2', be: 575 },
  { element: 'Mn', orbital: '2p3/2', be: 641 },
  { element: 'Fe', orbital: '2p3/2', be: 710 },
  { element: 'Co', orbital: '2p3/2', be: 779 },
  { element: 'Ni', orbital: '2p3/2', be: 855 },
  { element: 'Cu', orbital: '2p3/2', be: 931 },
  { element: 'Zn', orbital: '2p3/2', be: 1021 },
  { element: 'Ga', orbital: '2p3/2', be: 1116 },
  { element: 'Ge', orbital: '2p3/2', be: 1217 },
  { element: 'B', orbital: '2p', be: 5 },
  { element: 'C', orbital: '2p', be: 7 },
  { element: 'N', orbital: '2p', be: 9 },
  { element: 'O', orbital: '2p', be: 7 },
  { element: 'F', orbital: '2p', be: 9 },
  { element: 'Ne', orbital: '2p', be: 18 },
  { element: 'Na', orbital: '2p', be: 31 },
  { element: 'Mg', orbital: '2p', be: 52 },
  { element: 'Al', orbital: '2p', be: 73 },
  { element: 'Si', orbital: '2p', be: 99 },
  { element: 'P', orbital: '2p', be: 135 },
  { element: 'S', orbital: '2p', be: 164 },
  { element: 'Cl', orbital: '2p', be: 200 },
  { element: 'Ar', orbital: '2p', be: 245 },
  { element: 'K', orbital: '2p', be: 294 },
  { element: 'Ca', orbital: '2p', be: 347 },
  { element: 'Sc', orbital: '2p', be: 402 },
  { element: 'Ti', orbital: '2p', be: 455 },
  { element: 'V', orbital: '2p', be: 513 },
  { element: 'Cr', orbital: '2p', be: 575 },
  { element: 'Mn', orbital: '2p', be: 641 },
  { element: 'Fe', orbital: '2p', be: 710 },
  { element: 'Co', orbital: '2p', be: 779 },
  { element: 'Ni', orbital: '2p', be: 855 },
  { element: 'Cu', orbital: '2p', be: 931 },
  { element: 'Zn', orbital: '2p', be: 1021 },
  { element: 'Ga', orbital: '2p', be: 1116 },
  { element: 'Ge', orbital: '2p', be: 1217 },
  { element: 'Na', orbital: '3s', be: 1 },
  { element: 'Mg', orbital: '3s', be: 2 },
  { element: 'Al', orbital: '3s', be: 1 },
  { element: 'Si', orbital: '3s', be: 8 },
  { element: 'P', orbital: '3s', be: 16 },
  { element: 'S', orbital: '3s', be: 16 },
  { element: 'Cl', orbital: '3s', be: 18 },
  { element: 'Ar', orbital: '3s', be: 25 },
  { element: 'K', orbital: '3s', be: 34 },
  { element: 'Ca', orbital: '3s', be: 44 },
  { element: 'Sc', orbital: '3s', be: 54 },
  { element: 'Ti', orbital: '3s', be: 59 },
  { element: 'V', orbital: '3s', be: 66 },
  { element: 'Cr', orbital: '3s', be: 74 },
  { element: 'Mn', orbital: '3s', be: 84 },
  { element: 'Fe', orbital: '3s', be: 95 },
  { element: 'Co', orbital: '3s', be: 101 },
  { element: 'Ni', orbital: '3s', be: 112 },
  { element: 'Cu', orbital: '3s', be: 120 },
  { element: 'Zn', orbital: '3s', be: 137 },
  { element: 'Ga', orbital: '3s', be: 158 },
  { element: 'Ge', orbital: '3s', be: 181 },
  { element: 'As', orbital: '3s', be: 204 },
  { element: 'Se', orbital: '3s', be: 232 },
  { element: 'Br', orbital: '3s', be: 257 },
  { element: 'Kr', orbital: '3s', be: 289 },
  { element: 'Rb', orbital: '3s', be: 322 },
  { element: 'Sr', orbital: '3s', be: 358 },
  { element: 'Y', orbital: '3s', be: 395 },
  { element: 'Zr', orbital: '3s', be: 431 },
  { element: 'Nb', orbital: '3s', be: 469 },
  { element: 'Mo', orbital: '3s', be: 505 },
  { element: 'Tc', orbital: '3s', be: 544 },
  { element: 'Ru', orbital: '3s', be: 585 },
  { element: 'Rh', orbital: '3s', be: 627 },
  { element: 'Pd', orbital: '3s', be: 670 },
  { element: 'Ag', orbital: '3s', be: 717 },
  { element: 'Cd', orbital: '3s', be: 770 },
  { element: 'In', orbital: '3s', be: 826 },
  { element: 'Sn', orbital: '3s', be: 884 },
  { element: 'Sb', orbital: '3s', be: 944 },
  { element: 'Te', orbital: '3s', be: 1006 },
  { element: 'I', orbital: '3s', be: 1072 },
  { element: 'Xe', orbital: '3s', be: 1145 },
  { element: 'Cs', orbital: '3s', be: 1217 },
  { element: 'Si', orbital: '3p1/2', be: 3 },
  { element: 'P', orbital: '3p1/2', be: 10 },
  { element: 'S', orbital: '3p1/2', be: 8 },
  { element: 'Cl', orbital: '3p1/2', be: 7 },
  { element: 'Ar', orbital: '3p1/2', be: 12 },
  { element: 'K', orbital: '3p1/2', be: 18 },
  { element: 'Ca', orbital: '3p1/2', be: 26 },
  { element: 'Sc', orbital: '3p1/2', be: 32 },
  { element: 'Ti', orbital: '3p1/2', be: 34 },
  { element: 'V', orbital: '3p1/2', be: 38 },
  { element: 'Cr', orbital: '3p1/2', be: 43 },
  { element: 'Mn', orbital: '3p1/2', be: 49 },
  { element: 'Fe', orbital: '3p1/2', be: 56 },
  { element: 'Co', orbital: '3p1/2', be: 60 },
  { element: 'Ni', orbital: '3p1/2', be: 68 },
  { element: 'Cu', orbital: '3p1/2', be: 74 },
  { element: 'Zn', orbital: '3p1/2', be: 87 },
  { element: 'Ga', orbital: '3p1/2', be: 107 },
  { element: 'Ge', orbital: '3p1/2', be: 129 },
  { element: 'As', orbital: '3p1/2', be: 147 },
  { element: 'Se', orbital: '3p1/2', be: 168 },
  { element: 'Br', orbital: '3p1/2', be: 189 },
  { element: 'Kr', orbital: '3p1/2', be: 223 },
  { element: 'Rb', orbital: '3p1/2', be: 248 },
  { element: 'Sr', orbital: '3p1/2', be: 280 },
  { element: 'Y', orbital: '3p1/2', be: 313 },
  { element: 'Zr', orbital: '3p1/2', be: 345 },
  { element: 'Nb', orbital: '3p1/2', be: 379 },
  { element: 'Mo', orbital: '3p1/2', be: 410 },
  { element: 'Tc', orbital: '3p1/2', be: 445 },
  { element: 'Ru', orbital: '3p1/2', be: 483 },
  { element: 'Rh', orbital: '3p1/2', be: 521 },
  { element: 'Pd', orbital: '3p1/2', be: 559 },
  { element: 'Ag', orbital: '3p1/2', be: 602 },
  { element: 'Cd', orbital: '3p1/2', be: 651 },
  { element: 'In', orbital: '3p1/2', be: 702 },
  { element: 'Sn', orbital: '3p1/2', be: 757 },
  { element: 'Sb', orbital: '3p1/2', be: 812 },
  { element: 'Te', orbital: '3p1/2', be: 870 },
  { element: 'I', orbital: '3p1/2', be: 931 },
  { element: 'Xe', orbital: '3p1/2', be: 999 },
  { element: 'Cs', orbital: '3p1/2', be: 1065 },
  { element: 'Ba', orbital: '3p1/2', be: 1137 },
  { element: 'La', orbital: '3p1/2', be: 1205 },
  { element: 'Si', orbital: '3p3/2', be: 3 },
  { element: 'P', orbital: '3p3/2', be: 10 },
  { element: 'S', orbital: '3p3/2', be: 8 },
  { element: 'Cl', orbital: '3p3/2', be: 7 },
  { element: 'Ar', orbital: '3p3/2', be: 12 },
  { element: 'K', orbital: '3p3/2', be: 18 },
  { element: 'Ca', orbital: '3p3/2', be: 26 },
  { element: 'Sc', orbital: '3p3/2', be: 32 },
  { element: 'Ti', orbital: '3p3/2', be: 34 },
  { element: 'V', orbital: '3p3/2', be: 38 },
  { element: 'Cr', orbital: '3p3/2', be: 43 },
  { element: 'Mn', orbital: '3p3/2', be: 49 },
  { element: 'Fe', orbital: '3p3/2', be: 56 },
  { element: 'Co', orbital: '3p3/2', be: 60 },
  { element: 'Ni', orbital: '3p3/2', be: 68 },
  { element: 'Cu', orbital: '3p3/2', be: 74 },
  { element: 'Zn', orbital: '3p3/2', be: 87 },
  { element: 'Ga', orbital: '3p3/2', be: 103 },
  { element: 'Ge', orbital: '3p3/2', be: 122 },
  { element: 'As', orbital: '3p3/2', be: 141 },
  { element: 'Se', orbital: '3p3/2', be: 162 },
  { element: 'Br', orbital: '3p3/2', be: 182 },
  { element: 'Kr', orbital: '3p3/2', be: 214 },
  { element: 'Rb', orbital: '3p3/2', be: 239 },
  { element: 'Sr', orbital: '3p3/2', be: 269 },
  { element: 'Y', orbital: '3p3/2', be: 301 },
  { element: 'Zr', orbital: '3p3/2', be: 331 },
  { element: 'Nb', orbital: '3p3/2', be: 363 },
  { element: 'Mo', orbital: '3p3/2', be: 393 },
  { element: 'Tc', orbital: '3p3/2', be: 425 },
  { element: 'Ru', orbital: '3p3/2', be: 461 },
  { element: 'Rh', orbital: '3p3/2', be: 496 },
  { element: 'Pd', orbital: '3p3/2', be: 531 },
  { element: 'Ag', orbital: '3p3/2', be: 571 },
  { element: 'Cd', orbital: '3p3/2', be: 617 },
  { element: 'In', orbital: '3p3/2', be: 664 },
  { element: 'Sn', orbital: '3p3/2', be: 715 },
  { element: 'Sb', orbital: '3p3/2', be: 766 },
  { element: 'Te', orbital: '3p3/2', be: 819 },
  { element: 'I', orbital: '3p3/2', be: 875 },
  { element: 'Xe', orbital: '3p3/2', be: 937 },
  { element: 'Cs', orbital: '3p3/2', be: 998 },
  { element: 'Ba', orbital: '3p3/2', be: 1063 },
  { element: 'La', orbital: '3p3/2', be: 1124 },
  { element: 'Ce', orbital: '3p3/2', be: 1186 },
  { element: 'Pr', orbital: '3p3/2', be: 1243 },
  { element: 'Si', orbital: '3p', be: 3 },
  { element: 'P', orbital: '3p', be: 10 },
  { element: 'S', orbital: '3p', be: 8 },
  { element: 'Cl', orbital: '3p', be: 7 },
  { element: 'Ar', orbital: '3p', be: 12 },
  { element: 'K', orbital: '3p', be: 18 },
  { element: 'Ca', orbital: '3p', be: 26 },
  { element: 'Sc', orbital: '3p', be: 32 },
  { element: 'Ti', orbital: '3p', be: 34 },
  { element: 'V', orbital: '3p', be: 38 },
  { element: 'Cr', orbital: '3p', be: 43 },
  { element: 'Mn', orbital: '3p', be: 49 },
  { element: 'Fe', orbital: '3p', be: 56 },
  { element: 'Co', orbital: '3p', be: 60 },
  { element: 'Ni', orbital: '3p', be: 68 },
  { element: 'Cu', orbital: '3p', be: 74 },
  { element: 'Zn', orbital: '3p', be: 87 },
  { element: 'Ga', orbital: '3p', be: 103 },
  { element: 'Ge', orbital: '3p', be: 122 },
  { element: 'As', orbital: '3p', be: 141 },
  { element: 'Se', orbital: '3p', be: 162 },
  { element: 'Br', orbital: '3p', be: 182 },
  { element: 'Kr', orbital: '3p', be: 214 },
  { element: 'Rb', orbital: '3p', be: 239 },
  { element: 'Sr', orbital: '3p', be: 269 },
  { element: 'Y', orbital: '3p', be: 301 },
  { element: 'Zr', orbital: '3p', be: 331 },
  { element: 'Nb', orbital: '3p', be: 363 },
  { element: 'Mo', orbital: '3p', be: 393 },
  { element: 'Tc', orbital: '3p', be: 425 },
  { element: 'Ru', orbital: '3p', be: 461 },
  { element: 'Rh', orbital: '3p', be: 496 },
  { element: 'Pd', orbital: '3p', be: 531 },
  { element: 'Ag', orbital: '3p', be: 571 },
  { element: 'Cd', orbital: '3p', be: 617 },
  { element: 'In', orbital: '3p', be: 664 },
  { element: 'Sn', orbital: '3p', be: 715 },
  { element: 'Sb', orbital: '3p', be: 766 },
  { element: 'Te', orbital: '3p', be: 819 },
  { element: 'I', orbital: '3p', be: 875 },
  { element: 'Xe', orbital: '3p', be: 937 },
  { element: 'Cs', orbital: '3p', be: 998 },
  { element: 'Ba', orbital: '3p', be: 1063 },
  { element: 'La', orbital: '3p', be: 1124 },
  { element: 'Ce', orbital: '3p', be: 1186 },
  { element: 'Pr', orbital: '3p', be: 1243 },
  { element: 'Sc', orbital: '3d3/2', be: 7 },
  { element: 'Ti', orbital: '3d3/2', be: 3 },
  { element: 'V', orbital: '3d3/2', be: 2 },
  { element: 'Cr', orbital: '3d3/2', be: 2 },
  { element: 'Mn', orbital: '3d3/2', be: 4 },
  { element: 'Fe', orbital: '3d3/2', be: 6 },
  { element: 'Co', orbital: '3d3/2', be: 3 },
  { element: 'Ni', orbital: '3d3/2', be: 4 },
  { element: 'Cu', orbital: '3d3/2', be: 2 },
  { element: 'Zn', orbital: '3d3/2', be: 9 },
  { element: 'Ga', orbital: '3d3/2', be: 18 },
  { element: 'Ge', orbital: '3d3/2', be: 29 },
  { element: 'As', orbital: '3d3/2', be: 41 },
  { element: 'Se', orbital: '3d3/2', be: 57 },
  { element: 'Br', orbital: '3d3/2', be: 70 },
  { element: 'Kr', orbital: '3d3/2', be: 89 },
  { element: 'Rb', orbital: '3d3/2', be: 112 },
  { element: 'Sr', orbital: '3d3/2', be: 135 },
  { element: 'Y', orbital: '3d3/2', be: 160 },
  { element: 'Zr', orbital: '3d3/2', be: 183 },
  { element: 'Nb', orbital: '3d3/2', be: 208 },
  { element: 'Mo', orbital: '3d3/2', be: 230 },
  { element: 'Tc', orbital: '3d3/2', be: 257 },
  { element: 'Ru', orbital: '3d3/2', be: 284 },
  { element: 'Rh', orbital: '3d3/2', be: 312 },
  { element: 'Pd', orbital: '3d3/2', be: 340 },
  { element: 'Ag', orbital: '3d3/2', be: 373 },
  { element: 'Cd', orbital: '3d3/2', be: 411 },
  { element: 'In', orbital: '3d3/2', be: 451 },
  { element: 'Sn', orbital: '3d3/2', be: 494 },
  { element: 'Sb', orbital: '3d3/2', be: 537 },
  { element: 'Te', orbital: '3d3/2', be: 582 },
  { element: 'I', orbital: '3d3/2', be: 631 },
  { element: 'Xe', orbital: '3d3/2', be: 685 },
  { element: 'Cs', orbital: '3d3/2', be: 740 },
  { element: 'Ba', orbital: '3d3/2', be: 796 },
  { element: 'La', orbital: '3d3/2', be: 849 },
  { element: 'Ce', orbital: '3d3/2', be: 902 },
  { element: 'Pr', orbital: '3d3/2', be: 951 },
  { element: 'Nd', orbital: '3d3/2', be: 1000 },
  { element: 'Pm', orbital: '3d3/2', be: 1052 },
  { element: 'Sm', orbital: '3d3/2', be: 1107 },
  { element: 'Eu', orbital: '3d3/2', be: 1161 },
  { element: 'Gd', orbital: '3d3/2', be: 1218 },
  { element: 'Sc', orbital: '3d5/2', be: 7 },
  { element: 'Ti', orbital: '3d5/2', be: 3 },
  { element: 'V', orbital: '3d5/2', be: 2 },
  { element: 'Cr', orbital: '3d5/2', be: 2 },
  { element: 'Mn', orbital: '3d5/2', be: 4 },
  { element: 'Fe', orbital: '3d5/2', be: 6 },
  { element: 'Co', orbital: '3d5/2', be: 3 },
  { element: 'Ni', orbital: '3d5/2', be: 4 },
  { element: 'Cu', orbital: '3d5/2', be: 2 },
  { element: 'Zn', orbital: '3d5/2', be: 9 },
  { element: 'Ga', orbital: '3d5/2', be: 18 },
  { element: 'Ge', orbital: '3d5/2', be: 29 },
  { element: 'As', orbital: '3d5/2', be: 41 },
  { element: 'Se', orbital: '3d5/2', be: 57 },
  { element: 'Br', orbital: '3d5/2', be: 69 },
  { element: 'Kr', orbital: '3d5/2', be: 89 },
  { element: 'Rb', orbital: '3d5/2', be: 111 },
  { element: 'Sr', orbital: '3d5/2', be: 133 },
  { element: 'Y', orbital: '3d5/2', be: 158 },
  { element: 'Zr', orbital: '3d5/2', be: 180 },
  { element: 'Nb', orbital: '3d5/2', be: 205 },
  { element: 'Mo', orbital: '3d5/2', be: 227 },
  { element: 'Tc', orbital: '3d5/2', be: 253 },
  { element: 'Ru', orbital: '3d5/2', be: 279 },
  { element: 'Rh', orbital: '3d5/2', be: 307 },
  { element: 'Pd', orbital: '3d5/2', be: 335 },
  { element: 'Ag', orbital: '3d5/2', be: 367 },
  { element: 'Cd', orbital: '3d5/2', be: 404 },
  { element: 'In', orbital: '3d5/2', be: 443 },
  { element: 'Sn', orbital: '3d5/2', be: 485 },
  { element: 'Sb', orbital: '3d5/2', be: 528 },
  { element: 'Te', orbital: '3d5/2', be: 572 },
  { element: 'I', orbital: '3d5/2', be: 620 },
  { element: 'Xe', orbital: '3d5/2', be: 672 },
  { element: 'Cs', orbital: '3d5/2', be: 726 },
  { element: 'Ba', orbital: '3d5/2', be: 781 },
  { element: 'La', orbital: '3d5/2', be: 832 },
  { element: 'Ce', orbital: '3d5/2', be: 884 },
  { element: 'Pr', orbital: '3d5/2', be: 931 },
  { element: 'Nd', orbital: '3d5/2', be: 978 },
  { element: 'Pm', orbital: '3d5/2', be: 1027 },
  { element: 'Sm', orbital: '3d5/2', be: 1081 },
  { element: 'Eu', orbital: '3d5/2', be: 1131 },
  { element: 'Gd', orbital: '3d5/2', be: 1186 },
  { element: 'Tb', orbital: '3d5/2', be: 1242 },
  { element: 'Sc', orbital: '3d', be: 7 },
  { element: 'Ti', orbital: '3d', be: 3 },
  { element: 'V', orbital: '3d', be: 2 },
  { element: 'Cr', orbital: '3d', be: 2 },
  { element: 'Mn', orbital: '3d', be: 4 },
  { element: 'Fe', orbital: '3d', be: 6 },
  { element: 'Co', orbital: '3d', be: 3 },
  { element: 'Ni', orbital: '3d', be: 4 },
  { element: 'Cu', orbital: '3d', be: 2 },
  { element: 'Zn', orbital: '3d', be: 9 },
  { element: 'Ga', orbital: '3d', be: 18 },
  { element: 'Ge', orbital: '3d', be: 29 },
  { element: 'As', orbital: '3d', be: 41 },
  { element: 'Se', orbital: '3d', be: 57 },
  { element: 'Br', orbital: '3d', be: 69 },
  { element: 'Kr', orbital: '3d', be: 89 },
  { element: 'Rb', orbital: '3d', be: 111 },
  { element: 'Sr', orbital: '3d', be: 133 },
  { element: 'Y', orbital: '3d', be: 158 },
  { element: 'Zr', orbital: '3d', be: 180 },
  { element: 'Nb', orbital: '3d', be: 205 },
  { element: 'Mo', orbital: '3d', be: 227 },
  { element: 'Tc', orbital: '3d', be: 253 },
  { element: 'Ru', orbital: '3d', be: 279 },
  { element: 'Rh', orbital: '3d', be: 307 },
  { element: 'Pd', orbital: '3d', be: 335 },
  { element: 'Ag', orbital: '3d', be: 367 },
  { element: 'Cd', orbital: '3d', be: 404 },
  { element: 'In', orbital: '3d', be: 443 },
  { element: 'Sn', orbital: '3d', be: 485 },
  { element: 'Sb', orbital: '3d', be: 528 },
  { element: 'Te', orbital: '3d', be: 572 },
  { element: 'I', orbital: '3d', be: 620 },
  { element: 'Xe', orbital: '3d', be: 672 },
  { element: 'Cs', orbital: '3d', be: 726 },
  { element: 'Ba', orbital: '3d', be: 781 },
  { element: 'La', orbital: '3d', be: 832 },
  { element: 'Ce', orbital: '3d', be: 884 },
  { element: 'Pr', orbital: '3d', be: 931 },
  { element: 'Nd', orbital: '3d', be: 978 },
  { element: 'Pm', orbital: '3d', be: 1027 },
  { element: 'Sm', orbital: '3d', be: 1081 },
  { element: 'Eu', orbital: '3d', be: 1131 },
  { element: 'Gd', orbital: '3d', be: 1186 },
  { element: 'Tb', orbital: '3d', be: 1242 },
  { element: 'Br', orbital: '4s', be: 27 },
  { element: 'Kr', orbital: '4s', be: 24 },
  { element: 'Rb', orbital: '4s', be: 30 },
  { element: 'Sr', orbital: '4s', be: 38 },
  { element: 'Y', orbital: '4s', be: 46 },
  { element: 'Zr', orbital: '4s', be: 52 },
  { element: 'Nb', orbital: '4s', be: 58 },
  { element: 'Mo', orbital: '4s', be: 62 },
  { element: 'Tc', orbital: '4s', be: 68 },
  { element: 'Ru', orbital: '4s', be: 75 },
  { element: 'Rh', orbital: '4s', be: 81 },
  { element: 'Pd', orbital: '4s', be: 86 },
  { element: 'Ag', orbital: '4s', be: 95 },
  { element: 'Cd', orbital: '4s', be: 108 },
  { element: 'In', orbital: '4s', be: 122 },
  { element: 'Sn', orbital: '4s', be: 137 },
  { element: 'Sb', orbital: '4s', be: 152 },
  { element: 'Te', orbital: '4s', be: 168 },
  { element: 'I', orbital: '4s', be: 186 },
  { element: 'Xe', orbital: '4s', be: 208 },
  { element: 'Cs', orbital: '4s', be: 231 },
  { element: 'Ba', orbital: '4s', be: 253 },
  { element: 'La', orbital: '4s', be: 271 },
  { element: 'Ce', orbital: '4s', be: 290 },
  { element: 'Pr', orbital: '4s', be: 305 },
  { element: 'Nd', orbital: '4s', be: 316 },
  { element: 'Pm', orbital: '4s', be: 331 },
  { element: 'Sm', orbital: '4s', be: 347 },
  { element: 'Eu', orbital: '4s', be: 360 },
  { element: 'Gd', orbital: '4s', be: 376 },
  { element: 'Tb', orbital: '4s', be: 398 },
  { element: 'Dy', orbital: '4s', be: 416 },
  { element: 'Ho', orbital: '4s', be: 436 },
  { element: 'Er', orbital: '4s', be: 449 },
  { element: 'Tm', orbital: '4s', be: 472 },
  { element: 'Yb', orbital: '4s', be: 487 },
  { element: 'Lu', orbital: '4s', be: 506 },
  { element: 'Hf', orbital: '4s', be: 538 },
  { element: 'Ta', orbital: '4s', be: 566 },
  { element: 'W', orbital: '4s', be: 595 },
  { element: 'Re', orbital: '4s', be: 625 },
  { element: 'Os', orbital: '4s', be: 655 },
  { element: 'Ir', orbital: '4s', be: 690 },
  { element: 'Pt', orbital: '4s', be: 724 },
  { element: 'Au', orbital: '4s', be: 759 },
  { element: 'Hg', orbital: '4s', be: 800 },
  { element: 'Tl', orbital: '4s', be: 846 },
  { element: 'Pb', orbital: '4s', be: 894 },
  { element: 'Bi', orbital: '4s', be: 939 },
  { element: 'Po', orbital: '4s', be: 995 },
  { element: 'At', orbital: '4s', be: 1042 },
  { element: 'Rn', orbital: '4s', be: 1097 },
  { element: 'Fr', orbital: '4s', be: 1153 },
  { element: 'Ra', orbital: '4s', be: 1208 },
  { element: 'U', orbital: '4s', be: 1043 },
  { element: 'Ga', orbital: '4p1/2', be: 1 },
  { element: 'Ge', orbital: '4p1/2', be: 3 },
  { element: 'As', orbital: '4p1/2', be: 3 },
  { element: 'Se', orbital: '4p1/2', be: 6 },
  { element: 'Br', orbital: '4p1/2', be: 5 },
  { element: 'Kr', orbital: '4p1/2', be: 11 },
  { element: 'Rb', orbital: '4p1/2', be: 15 },
  { element: 'Sr', orbital: '4p1/2', be: 20 },
  { element: 'Y', orbital: '4p1/2', be: 26 },
  { element: 'Zr', orbital: '4p1/2', be: 29 },
  { element: 'Nb', orbital: '4p1/2', be: 34 },
  { element: 'Mo', orbital: '4p1/2', be: 35 },
  { element: 'Tc', orbital: '4p1/2', be: 39 },
  { element: 'Ru', orbital: '4p1/2', be: 43 },
  { element: 'Rh', orbital: '4p1/2', be: 48 },
  { element: 'Pd', orbital: '4p1/2', be: 51 },
  { element: 'Ag', orbital: '4p1/2', be: 62 },
  { element: 'Cd', orbital: '4p1/2', be: 67 },
  { element: 'In', orbital: '4p1/2', be: 77 },
  { element: 'Sn', orbital: '4p1/2', be: 89 },
  { element: 'Sb', orbital: '4p1/2', be: 99 },
  { element: 'Te', orbital: '4p1/2', be: 110 },
  { element: 'I', orbital: '4p1/2', be: 123 },
  { element: 'Xe', orbital: '4p1/2', be: 147 },
  { element: 'Cs', orbital: '4p1/2', be: 172 },
  { element: 'Ba', orbital: '4p1/2', be: 192 },
  { element: 'La', orbital: '4p1/2', be: 206 },
  { element: 'Ce', orbital: '4p1/2', be: 224 },
  { element: 'Pr', orbital: '4p1/2', be: 237 },
  { element: 'Nd', orbital: '4p1/2', be: 244 },
  { element: 'Pm', orbital: '4p1/2', be: 255 },
  { element: 'Sm', orbital: '4p1/2', be: 267 },
  { element: 'Eu', orbital: '4p1/2', be: 284 },
  { element: 'Gd', orbital: '4p1/2', be: 289 },
  { element: 'Tb', orbital: '4p1/2', be: 311 },
  { element: 'Dy', orbital: '4p1/2', be: 332 },
  { element: 'Ho', orbital: '4p1/2', be: 343 },
  { element: 'Er', orbital: '4p1/2', be: 366 },
  { element: 'Tm', orbital: '4p1/2', be: 386 },
  { element: 'Yb', orbital: '4p1/2', be: 396 },
  { element: 'Lu', orbital: '4p1/2', be: 410 },
  { element: 'Hf', orbital: '4p1/2', be: 437 },
  { element: 'Ta', orbital: '4p1/2', be: 465 },
  { element: 'W', orbital: '4p1/2', be: 492 },
  { element: 'Re', orbital: '4p1/2', be: 518 },
  { element: 'Os', orbital: '4p1/2', be: 547 },
  { element: 'Ir', orbital: '4p1/2', be: 577 },
  { element: 'Pt', orbital: '4p1/2', be: 608 },
  { element: 'Au', orbital: '4p1/2', be: 644 },
  { element: 'Hg', orbital: '4p1/2', be: 677 },
  { element: 'Tl', orbital: '4p1/2', be: 722 },
  { element: 'Pb', orbital: '4p1/2', be: 764 },
  { element: 'Bi', orbital: '4p1/2', be: 806 },
  { element: 'Po', orbital: '4p1/2', be: 851 },
  { element: 'At', orbital: '4p1/2', be: 886 },
  { element: 'Rn', orbital: '4p1/2', be: 929 },
  { element: 'Fr', orbital: '4p1/2', be: 980 },
  { element: 'Ra', orbital: '4p1/2', be: 1058 },
  { element: 'Ac', orbital: '4p1/2', be: 1080 },
  { element: 'Th', orbital: '4p1/2', be: 1168 },
  { element: 'Ga', orbital: '4p3/2', be: 1 },
  { element: 'Ge', orbital: '4p3/2', be: 3 },
  { element: 'As', orbital: '4p3/2', be: 3 },
  { element: 'Se', orbital: '4p3/2', be: 6 },
  { element: 'Br', orbital: '4p3/2', be: 5 },
  { element: 'Kr', orbital: '4p3/2', be: 11 },
  { element: 'Rb', orbital: '4p3/2', be: 14 },
  { element: 'Sr', orbital: '4p3/2', be: 20 },
  { element: 'Y', orbital: '4p3/2', be: 26 },
  { element: 'Zr', orbital: '4p3/2', be: 29 },
  { element: 'Nb', orbital: '4p3/2', be: 34 },
  { element: 'Mo', orbital: '4p3/2', be: 35 },
  { element: 'Tc', orbital: '4p3/2', be: 39 },
  { element: 'Ru', orbital: '4p3/2', be: 43 },
  { element: 'Rh', orbital: '4p3/2', be: 48 },
  { element: 'Pd', orbital: '4p3/2', be: 56 },
  { element: 'Ag', orbital: '4p3/2', be: 56 },
  { element: 'Cd', orbital: '4p3/2', be: 67 },
  { element: 'In', orbital: '4p3/2', be: 77 },
  { element: 'Sn', orbital: '4p3/2', be: 89 },
  { element: 'Sb', orbital: '4p3/2', be: 99 },
  { element: 'Te', orbital: '4p3/2', be: 110 },
  { element: 'I', orbital: '4p3/2', be: 123 },
  { element: 'Xe', orbital: '4p3/2', be: 147 },
  { element: 'Cs', orbital: '4p3/2', be: 162 },
  { element: 'Ba', orbital: '4p3/2', be: 180 },
  { element: 'La', orbital: '4p3/2', be: 192 },
  { element: 'Ce', orbital: '4p3/2', be: 208 },
  { element: 'Pr', orbital: '4p3/2', be: 218 },
  { element: 'Nd', orbital: '4p3/2', be: 225 },
  { element: 'Pm', orbital: '4p3/2', be: 237 },
  { element: 'Sm', orbital: '4p3/2', be: 249 },
  { element: 'Eu', orbital: '4p3/2', be: 257 },
  { element: 'Gd', orbital: '4p3/2', be: 271 },
  { element: 'Tb', orbital: '4p3/2', be: 286 },
  { element: 'Dy', orbital: '4p3/2', be: 293 },
  { element: 'Ho', orbital: '4p3/2', be: 306 },
  { element: 'Er', orbital: '4p3/2', be: 320 },
  { element: 'Tm', orbital: '4p3/2', be: 337 },
  { element: 'Yb', orbital: '4p3/2', be: 343 },
  { element: 'Lu', orbital: '4p3/2', be: 359 },
  { element: 'Hf', orbital: '4p3/2', be: 380 },
  { element: 'Ta', orbital: '4p3/2', be: 405 },
  { element: 'W', orbital: '4p3/2', be: 426 },
  { element: 'Re', orbital: '4p3/2', be: 445 },
  { element: 'Os', orbital: '4p3/2', be: 469 },
  { element: 'Ir', orbital: '4p3/2', be: 495 },
  { element: 'Pt', orbital: '4p3/2', be: 519 },
  { element: 'Au', orbital: '4p3/2', be: 546 },
  { element: 'Hg', orbital: '4p3/2', be: 571 },
  { element: 'Tl', orbital: '4p3/2', be: 609 },
  { element: 'Pb', orbital: '4p3/2', be: 645 },
  { element: 'Bi', orbital: '4p3/2', be: 679 },
  { element: 'Po', orbital: '4p3/2', be: 705 },
  { element: 'At', orbital: '4p3/2', be: 740 },
  { element: 'Rn', orbital: '4p3/2', be: 768 },
  { element: 'Fr', orbital: '4p3/2', be: 810 },
  { element: 'Ra', orbital: '4p3/2', be: 879 },
  { element: 'Ac', orbital: '4p3/2', be: 890 },
  { element: 'Th', orbital: '4p3/2', be: 968 },
  { element: 'Ga', orbital: '4p', be: 1 },
  { element: 'Ge', orbital: '4p', be: 3 },
  { element: 'As', orbital: '4p', be: 3 },
  { element: 'Se', orbital: '4p', be: 6 },
  { element: 'Br', orbital: '4p', be: 5 },
  { element: 'Kr', orbital: '4p', be: 11 },
  { element: 'Rb', orbital: '4p', be: 14 },
  { element: 'Sr', orbital: '4p', be: 20 },
  { element: 'Y', orbital: '4p', be: 26 },
  { element: 'Zr', orbital: '4p', be: 29 },
  { element: 'Nb', orbital: '4p', be: 34 },
  { element: 'Mo', orbital: '4p', be: 35 },
  { element: 'Tc', orbital: '4p', be: 39 },
  { element: 'Ru', orbital: '4p', be: 43 },
  { element: 'Rh', orbital: '4p', be: 48 },
  { element: 'Pd', orbital: '4p', be: 56 },
  { element: 'Ag', orbital: '4p', be: 56 },
  { element: 'Cd', orbital: '4p', be: 67 },
  { element: 'In', orbital: '4p', be: 77 },
  { element: 'Sn', orbital: '4p', be: 89 },
  { element: 'Sb', orbital: '4p', be: 99 },
  { element: 'Te', orbital: '4p', be: 110 },
  { element: 'I', orbital: '4p', be: 123 },
  { element: 'Xe', orbital: '4p', be: 147 },
  { element: 'Cs', orbital: '4p', be: 162 },
  { element: 'Ba', orbital: '4p', be: 180 },
  { element: 'La', orbital: '4p', be: 192 },
  { element: 'Ce', orbital: '4p', be: 208 },
  { element: 'Pr', orbital: '4p', be: 218 },
  { element: 'Nd', orbital: '4p', be: 225 },
  { element: 'Pm', orbital: '4p', be: 237 },
  { element: 'Sm', orbital: '4p', be: 249 },
  { element: 'Eu', orbital: '4p', be: 257 },
  { element: 'Gd', orbital: '4p', be: 271 },
  { element: 'Tb', orbital: '4p', be: 286 },
  { element: 'Dy', orbital: '4p', be: 293 },
  { element: 'Ho', orbital: '4p', be: 306 },
  { element: 'Er', orbital: '4p', be: 320 },
  { element: 'Tm', orbital: '4p', be: 337 },
  { element: 'Yb', orbital: '4p', be: 343 },
  { element: 'Lu', orbital: '4p', be: 359 },
  { element: 'Hf', orbital: '4p', be: 380 },
  { element: 'Ta', orbital: '4p', be: 405 },
  { element: 'W', orbital: '4p', be: 426 },
  { element: 'Re', orbital: '4p', be: 445 },
  { element: 'Os', orbital: '4p', be: 469 },
  { element: 'Ir', orbital: '4p', be: 495 },
  { element: 'Pt', orbital: '4p', be: 519 },
  { element: 'Au', orbital: '4p', be: 546 },
  { element: 'Hg', orbital: '4p', be: 571 },
  { element: 'Tl', orbital: '4p', be: 609 },
  { element: 'Pb', orbital: '4p', be: 645 },
  { element: 'Bi', orbital: '4p', be: 679 },
  { element: 'Po', orbital: '4p', be: 705 },
  { element: 'At', orbital: '4p', be: 740 },
  { element: 'Rn', orbital: '4p', be: 768 },
  { element: 'Fr', orbital: '4p', be: 810 },
  { element: 'Ra', orbital: '4p', be: 879 },
  { element: 'Ac', orbital: '4p', be: 890 },
  { element: 'Th', orbital: '4p', be: 968 },
  { element: 'Y', orbital: '4d3/2', be: 3 },
  { element: 'Zr', orbital: '4d3/2', be: 3 },
  { element: 'Nb', orbital: '4d3/2', be: 4 },
  { element: 'Mo', orbital: '4d3/2', be: 2 },
  { element: 'Tc', orbital: '4d3/2', be: 2 },
  { element: 'Ru', orbital: '4d3/2', be: 2 },
  { element: 'Rh', orbital: '4d3/2', be: 3 },
  { element: 'Pd', orbital: '4d3/2', be: 1 },
  { element: 'Ag', orbital: '4d3/2', be: 3 },
  { element: 'Cd', orbital: '4d3/2', be: 9 },
  { element: 'In', orbital: '4d3/2', be: 16 },
  { element: 'Sn', orbital: '4d3/2', be: 24 },
  { element: 'Sb', orbital: '4d3/2', be: 32 },
  { element: 'Te', orbital: '4d3/2', be: 40 },
  { element: 'I', orbital: '4d3/2', be: 50 },
  { element: 'Xe', orbital: '4d3/2', be: 63 },
  { element: 'Cs', orbital: '4d3/2', be: 79 },
  { element: 'Ba', orbital: '4d3/2', be: 93 },
  { element: 'La', orbital: '4d3/2', be: 99 },
  { element: 'Ce', orbital: '4d3/2', be: 111 },
  { element: 'Pr', orbital: '4d3/2', be: 114 },
  { element: 'Nd', orbital: '4d3/2', be: 118 },
  { element: 'Pm', orbital: '4d3/2', be: 121 },
  { element: 'Sm', orbital: '4d3/2', be: 130 },
  { element: 'Eu', orbital: '4d3/2', be: 134 },
  { element: 'Gd', orbital: '4d3/2', be: 141 },
  { element: 'Tb', orbital: '4d3/2', be: 148 },
  { element: 'Dy', orbital: '4d3/2', be: 154 },
  { element: 'Ho', orbital: '4d3/2', be: 161 },
  { element: 'Er', orbital: '4d3/2', be: 177 },
  { element: 'Tm', orbital: '4d3/2', be: 180 },
  { element: 'Yb', orbital: '4d3/2', be: 197 },
  { element: 'Lu', orbital: '4d3/2', be: 205 },
  { element: 'Hf', orbital: '4d3/2', be: 224 },
  { element: 'Ta', orbital: '4d3/2', be: 242 },
  { element: 'W', orbital: '4d3/2', be: 259 },
  { element: 'Re', orbital: '4d3/2', be: 274 },
  { element: 'Os', orbital: '4d3/2', be: 290 },
  { element: 'Ir', orbital: '4d3/2', be: 312 },
  { element: 'Pt', orbital: '4d3/2', be: 331 },
  { element: 'Au', orbital: '4d3/2', be: 352 },
  { element: 'Hg', orbital: '4d3/2', be: 379 },
  { element: 'Tl', orbital: '4d3/2', be: 407 },
  { element: 'Pb', orbital: '4d3/2', be: 435 },
  { element: 'Bi', orbital: '4d3/2', be: 464 },
  { element: 'Po', orbital: '4d3/2', be: 500 },
  { element: 'At', orbital: '4d3/2', be: 533 },
  { element: 'Rn', orbital: '4d3/2', be: 567 },
  { element: 'Fr', orbital: '4d3/2', be: 603 },
  { element: 'Ra', orbital: '4d3/2', be: 636 },
  { element: 'Ac', orbital: '4d3/2', be: 675 },
  { element: 'Th', orbital: '4d3/2', be: 714 },
  { element: 'U', orbital: '4d3/2', be: 781 },
  { element: 'Y', orbital: '4d5/2', be: 3 },
  { element: 'Zr', orbital: '4d5/2', be: 3 },
  { element: 'Nb', orbital: '4d5/2', be: 4 },
  { element: 'Mo', orbital: '4d5/2', be: 2 },
  { element: 'Tc', orbital: '4d5/2', be: 2 },
  { element: 'Ru', orbital: '4d5/2', be: 2 },
  { element: 'Rh', orbital: '4d5/2', be: 3 },
  { element: 'Pd', orbital: '4d5/2', be: 1 },
  { element: 'Ag', orbital: '4d5/2', be: 3 },
  { element: 'Cd', orbital: '4d5/2', be: 9 },
  { element: 'In', orbital: '4d5/2', be: 16 },
  { element: 'Sn', orbital: '4d5/2', be: 24 },
  { element: 'Sb', orbital: '4d5/2', be: 32 },
  { element: 'Te', orbital: '4d5/2', be: 40 },
  { element: 'I', orbital: '4d5/2', be: 50 },
  { element: 'Xe', orbital: '4d5/2', be: 63 },
  { element: 'Cs', orbital: '4d5/2', be: 77 },
  { element: 'Ba', orbital: '4d5/2', be: 90 },
  { element: 'La', orbital: '4d5/2', be: 99 },
  { element: 'Ce', orbital: '4d5/2', be: 111 },
  { element: 'Pr', orbital: '4d5/2', be: 114 },
  { element: 'Nd', orbital: '4d5/2', be: 118 },
  { element: 'Pm', orbital: '4d5/2', be: 121 },
  { element: 'Sm', orbital: '4d5/2', be: 130 },
  { element: 'Eu', orbital: '4d5/2', be: 134 },
  { element: 'Gd', orbital: '4d5/2', be: 141 },
  { element: 'Tb', orbital: '4d5/2', be: 148 },
  { element: 'Dy', orbital: '4d5/2', be: 154 },
  { element: 'Ho', orbital: '4d5/2', be: 161 },
  { element: 'Er', orbital: '4d5/2', be: 168 },
  { element: 'Tm', orbital: '4d5/2', be: 180 },
  { element: 'Yb', orbital: '4d5/2', be: 184 },
  { element: 'Lu', orbital: '4d5/2', be: 195 },
  { element: 'Hf', orbital: '4d5/2', be: 214 },
  { element: 'Ta', orbital: '4d5/2', be: 230 },
  { element: 'W', orbital: '4d5/2', be: 246 },
  { element: 'Re', orbital: '4d5/2', be: 260 },
  { element: 'Os', orbital: '4d5/2', be: 273 },
  { element: 'Ir', orbital: '4d5/2', be: 295 },
  { element: 'Pt', orbital: '4d5/2', be: 314 },
  { element: 'Au', orbital: '4d5/2', be: 334 },
  { element: 'Hg', orbital: '4d5/2', be: 360 },
  { element: 'Tl', orbital: '4d5/2', be: 386 },
  { element: 'Pb', orbital: '4d5/2', be: 413 },
  { element: 'Bi', orbital: '4d5/2', be: 440 },
  { element: 'Po', orbital: '4d5/2', be: 473 },
  { element: 'At', orbital: '4d5/2', be: 507 },
  { element: 'Rn', orbital: '4d5/2', be: 541 },
  { element: 'Fr', orbital: '4d5/2', be: 577 },
  { element: 'Ra', orbital: '4d5/2', be: 603 },
  { element: 'Ac', orbital: '4d5/2', be: 639 },
  { element: 'Th', orbital: '4d5/2', be: 677 },
  { element: 'U', orbital: '4d5/2', be: 739 },
  { element: 'Y', orbital: '4d', be: 3 },
  { element: 'Zr', orbital: '4d', be: 3 },
  { element: 'Nb', orbital: '4d', be: 4 },
  { element: 'Mo', orbital: '4d', be: 2 },
  { element: 'Tc', orbital: '4d', be: 2 },
  { element: 'Ru', orbital: '4d', be: 2 },
  { element: 'Rh', orbital: '4d', be: 3 },
  { element: 'Pd', orbital: '4d', be: 1 },
  { element: 'Ag', orbital: '4d', be: 3 },
  { element: 'Cd', orbital: '4d', be: 9 },
  { element: 'In', orbital: '4d', be: 16 },
  { element: 'Sn', orbital: '4d', be: 24 },
  { element: 'Sb', orbital: '4d', be: 32 },
  { element: 'Te', orbital: '4d', be: 40 },
  { element: 'I', orbital: '4d', be: 50 },
  { element: 'Xe', orbital: '4d', be: 63 },
  { element: 'Cs', orbital: '4d', be: 77 },
  { element: 'Ba', orbital: '4d', be: 90 },
  { element: 'La', orbital: '4d', be: 99 },
  { element: 'Ce', orbital: '4d', be: 111 },
  { element: 'Pr', orbital: '4d', be: 114 },
  { element: 'Nd', orbital: '4d', be: 118 },
  { element: 'Pm', orbital: '4d', be: 121 },
  { element: 'Sm', orbital: '4d', be: 130 },
  { element: 'Eu', orbital: '4d', be: 134 },
  { element: 'Gd', orbital: '4d', be: 141 },
  { element: 'Tb', orbital: '4d', be: 148 },
  { element: 'Dy', orbital: '4d', be: 154 },
  { element: 'Ho', orbital: '4d', be: 161 },
  { element: 'Er', orbital: '4d', be: 168 },
  { element: 'Tm', orbital: '4d', be: 180 },
  { element: 'Yb', orbital: '4d', be: 184 },
  { element: 'Lu', orbital: '4d', be: 195 },
  { element: 'Hf', orbital: '4d', be: 214 },
  { element: 'Ta', orbital: '4d', be: 230 },
  { element: 'W', orbital: '4d', be: 246 },
  { element: 'Re', orbital: '4d', be: 260 },
  { element: 'Os', orbital: '4d', be: 273 },
  { element: 'Ir', orbital: '4d', be: 295 },
  { element: 'Pt', orbital: '4d', be: 314 },
  { element: 'Au', orbital: '4d', be: 334 },
  { element: 'Hg', orbital: '4d', be: 360 },
  { element: 'Tl', orbital: '4d', be: 386 },
  { element: 'Pb', orbital: '4d', be: 413 },
  { element: 'Bi', orbital: '4d', be: 440 },
  { element: 'Po', orbital: '4d', be: 473 },
  { element: 'At', orbital: '4d', be: 507 },
  { element: 'Rn', orbital: '4d', be: 541 },
  { element: 'Fr', orbital: '4d', be: 577 },
  { element: 'Ra', orbital: '4d', be: 603 },
  { element: 'Ac', orbital: '4d', be: 639 },
  { element: 'Th', orbital: '4d', be: 677 },
  { element: 'U', orbital: '4d', be: 739 },
  { element: 'Ce', orbital: '4f5/2', be: 1 },
  { element: 'Pr', orbital: '4f5/2', be: 2 },
  { element: 'Nd', orbital: '4f5/2', be: 2 },
  { element: 'Pm', orbital: '4f5/2', be: 4 },
  { element: 'Sm', orbital: '4f5/2', be: 7 },
  { element: 'Tb', orbital: '4f5/2', be: 3 },
  { element: 'Dy', orbital: '4f5/2', be: 4 },
  { element: 'Ho', orbital: '4f5/2', be: 4 },
  { element: 'Er', orbital: '4f5/2', be: 4 },
  { element: 'Tm', orbital: '4f5/2', be: 5 },
  { element: 'Yb', orbital: '4f5/2', be: 6 },
  { element: 'Lu', orbital: '4f5/2', be: 7 },
  { element: 'Hf', orbital: '4f5/2', be: 19 },
  { element: 'Ta', orbital: '4f5/2', be: 27 },
  { element: 'W', orbital: '4f5/2', be: 37 },
  { element: 'Re', orbital: '4f5/2', be: 47 },
  { element: 'Os', orbital: '4f5/2', be: 52 },
  { element: 'Ir', orbital: '4f5/2', be: 63 },
  { element: 'Pt', orbital: '4f5/2', be: 74 },
  { element: 'Au', orbital: '4f5/2', be: 87 },
  { element: 'Hg', orbital: '4f5/2', be: 103 },
  { element: 'Tl', orbital: '4f5/2', be: 122 },
  { element: 'Pb', orbital: '4f5/2', be: 143 },
  { element: 'Bi', orbital: '4f5/2', be: 163 },
  { element: 'Po', orbital: '4f5/2', be: 184 },
  { element: 'At', orbital: '4f5/2', be: 210 },
  { element: 'Rn', orbital: '4f5/2', be: 238 },
  { element: 'Fr', orbital: '4f5/2', be: 268 },
  { element: 'Ra', orbital: '4f5/2', be: 299 },
  { element: 'Ac', orbital: '4f5/2', be: 319 },
  { element: 'Th', orbital: '4f5/2', be: 344 },
  { element: 'U', orbital: '4f5/2', be: 391 },
  { element: 'Ce', orbital: '4f7/2', be: 1 },
  { element: 'Pr', orbital: '4f7/2', be: 2 },
  { element: 'Nd', orbital: '4f7/2', be: 2 },
  { element: 'Pm', orbital: '4f7/2', be: 4 },
  { element: 'Sm', orbital: '4f7/2', be: 7 },
  { element: 'Tb', orbital: '4f7/2', be: 3 },
  { element: 'Dy', orbital: '4f7/2', be: 4 },
  { element: 'Ho', orbital: '4f7/2', be: 4 },
  { element: 'Er', orbital: '4f7/2', be: 4 },
  { element: 'Tm', orbital: '4f7/2', be: 5 },
  { element: 'Yb', orbital: '4f7/2', be: 6 },
  { element: 'Lu', orbital: '4f7/2', be: 7 },
  { element: 'Hf', orbital: '4f7/2', be: 18 },
  { element: 'Ta', orbital: '4f7/2', be: 25 },
  { element: 'W', orbital: '4f7/2', be: 34 },
  { element: 'Re', orbital: '4f7/2', be: 45 },
  { element: 'Os', orbital: '4f7/2', be: 50 },
  { element: 'Ir', orbital: '4f7/2', be: 60 },
  { element: 'Pt', orbital: '4f7/2', be: 70 },
  { element: 'Au', orbital: '4f7/2', be: 83 },
  { element: 'Hg', orbital: '4f7/2', be: 99 },
  { element: 'Tl', orbital: '4f7/2', be: 118 },
  { element: 'Pb', orbital: '4f7/2', be: 138 },
  { element: 'Bi', orbital: '4f7/2', be: 158 },
  { element: 'Po', orbital: '4f7/2', be: 184 },
  { element: 'At', orbital: '4f7/2', be: 210 },
  { element: 'Rn', orbital: '4f7/2', be: 238 },
  { element: 'Fr', orbital: '4f7/2', be: 268 },
  { element: 'Ra', orbital: '4f7/2', be: 299 },
  { element: 'Ac', orbital: '4f7/2', be: 319 },
  { element: 'Th', orbital: '4f7/2', be: 335 },
  { element: 'U', orbital: '4f7/2', be: 380 },
  { element: 'Ce', orbital: '4f', be: 1 },
  { element: 'Pr', orbital: '4f', be: 2 },
  { element: 'Nd', orbital: '4f', be: 2 },
  { element: 'Pm', orbital: '4f', be: 4 },
  { element: 'Sm', orbital: '4f', be: 7 },
  { element: 'Tb', orbital: '4f', be: 3 },
  { element: 'Dy', orbital: '4f', be: 4 },
  { element: 'Ho', orbital: '4f', be: 4 },
  { element: 'Er', orbital: '4f', be: 4 },
  { element: 'Tm', orbital: '4f', be: 5 },
  { element: 'Yb', orbital: '4f', be: 6 },
  { element: 'Lu', orbital: '4f', be: 7 },
  { element: 'Hf', orbital: '4f', be: 18 },
  { element: 'Ta', orbital: '4f', be: 25 },
  { element: 'W', orbital: '4f', be: 34 },
  { element: 'Re', orbital: '4f', be: 45 },
  { element: 'Os', orbital: '4f', be: 50 },
  { element: 'Ir', orbital: '4f', be: 60 },
  { element: 'Pt', orbital: '4f', be: 70 },
  { element: 'Au', orbital: '4f', be: 83 },
  { element: 'Hg', orbital: '4f', be: 99 },
  { element: 'Tl', orbital: '4f', be: 118 },
  { element: 'Pb', orbital: '4f', be: 138 },
  { element: 'Bi', orbital: '4f', be: 158 },
  { element: 'Po', orbital: '4f', be: 184 },
  { element: 'At', orbital: '4f', be: 210 },
  { element: 'Rn', orbital: '4f', be: 238 },
  { element: 'Fr', orbital: '4f', be: 268 },
  { element: 'Ra', orbital: '4f', be: 299 },
  { element: 'Ac', orbital: '4f', be: 319 },
  { element: 'Th', orbital: '4f', be: 335 },
  { element: 'U', orbital: '4f', be: 380 },
  { element: 'Sn', orbital: '5s', be: 1 },
  { element: 'Sb', orbital: '5s', be: 7 },
  { element: 'Te', orbital: '5s', be: 12 },
  { element: 'I', orbital: '5s', be: 14 },
  { element: 'Xe', orbital: '5s', be: 18 },
  { element: 'Cs', orbital: '5s', be: 23 },
  { element: 'Ba', orbital: '5s', be: 40 },
  { element: 'La', orbital: '5s', be: 33 },
  { element: 'Ce', orbital: '5s', be: 38 },
  { element: 'Pr', orbital: '5s', be: 38 },
  { element: 'Nd', orbital: '5s', be: 38 },
  { element: 'Pm', orbital: '5s', be: 38 },
  { element: 'Sm', orbital: '5s', be: 39 },
  { element: 'Eu', orbital: '5s', be: 32 },
  { element: 'Gd', orbital: '5s', be: 36 },
  { element: 'Tb', orbital: '5s', be: 40 },
  { element: 'Dy', orbital: '5s', be: 63 },
  { element: 'Ho', orbital: '5s', be: 51 },
  { element: 'Er', orbital: '5s', be: 60 },
  { element: 'Tm', orbital: '5s', be: 53 },
  { element: 'Yb', orbital: '5s', be: 53 },
  { element: 'Lu', orbital: '5s', be: 57 },
  { element: 'Hf', orbital: '5s', be: 65 },
  { element: 'Ta', orbital: '5s', be: 71 },
  { element: 'W', orbital: '5s', be: 77 },
  { element: 'Re', orbital: '5s', be: 83 },
  { element: 'Os', orbital: '5s', be: 84 },
  { element: 'Ir', orbital: '5s', be: 96 },
  { element: 'Pt', orbital: '5s', be: 102 },
  { element: 'Au', orbital: '5s', be: 108 },
  { element: 'Hg', orbital: '5s', be: 120 },
  { element: 'Tl', orbital: '5s', be: 137 },
  { element: 'Pb', orbital: '5s', be: 148 },
  { element: 'Bi', orbital: '5s', be: 160 },
  { element: 'Po', orbital: '5s', be: 177 },
  { element: 'At', orbital: '5s', be: 195 },
  { element: 'Rn', orbital: '5s', be: 214 },
  { element: 'Fr', orbital: '5s', be: 234 },
  { element: 'Ra', orbital: '5s', be: 254 },
  { element: 'Ac', orbital: '5s', be: 272 },
  { element: 'Th', orbital: '5s', be: 290 },
  { element: 'In', orbital: '5p1/2', be: 1 },
  { element: 'Sn', orbital: '5p1/2', be: 1 },
  { element: 'Sb', orbital: '5p1/2', be: 2 },
  { element: 'Te', orbital: '5p1/2', be: 2 },
  { element: 'I', orbital: '5p1/2', be: 3 },
  { element: 'Xe', orbital: '5p1/2', be: 7 },
  { element: 'Cs', orbital: '5p1/2', be: 13 },
  { element: 'Ba', orbital: '5p1/2', be: 17 },
  { element: 'La', orbital: '5p1/2', be: 15 },
  { element: 'Ce', orbital: '5p1/2', be: 20 },
  { element: 'Pr', orbital: '5p1/2', be: 23 },
  { element: 'Nd', orbital: '5p1/2', be: 22 },
  { element: 'Pm', orbital: '5p1/2', be: 22 },
  { element: 'Sm', orbital: '5p1/2', be: 22 },
  { element: 'Eu', orbital: '5p1/2', be: 22 },
  { element: 'Gd', orbital: '5p1/2', be: 21 },
  { element: 'Tb', orbital: '5p1/2', be: 26 },
  { element: 'Dy', orbital: '5p1/2', be: 26 },
  { element: 'Ho', orbital: '5p1/2', be: 20 },
  { element: 'Er', orbital: '5p1/2', be: 29 },
  { element: 'Tm', orbital: '5p1/2', be: 32 },
  { element: 'Yb', orbital: '5p1/2', be: 23 },
  { element: 'Lu', orbital: '5p1/2', be: 28 },
  { element: 'Hf', orbital: '5p1/2', be: 38 },
  { element: 'Ta', orbital: '5p1/2', be: 45 },
  { element: 'W', orbital: '5p1/2', be: 47 },
  { element: 'Re', orbital: '5p1/2', be: 46 },
  { element: 'Os', orbital: '5p1/2', be: 58 },
  { element: 'Ir', orbital: '5p1/2', be: 63 },
  { element: 'Pt', orbital: '5p1/2', be: 66 },
  { element: 'Au', orbital: '5p1/2', be: 72 },
  { element: 'Hg', orbital: '5p1/2', be: 81 },
  { element: 'Tl', orbital: '5p1/2', be: 100 },
  { element: 'Pb', orbital: '5p1/2', be: 105 },
  { element: 'Bi', orbital: '5p1/2', be: 117 },
  { element: 'Po', orbital: '5p1/2', be: 132 },
  { element: 'At', orbital: '5p1/2', be: 148 },
  { element: 'Rn', orbital: '5p1/2', be: 164 },
  { element: 'Fr', orbital: '5p1/2', be: 182 },
  { element: 'Ra', orbital: '5p1/2', be: 200 },
  { element: 'Ac', orbital: '5p1/2', be: 215 },
  { element: 'Th', orbital: '5p1/2', be: 229 },
  { element: 'In', orbital: '5p3/2', be: 1 },
  { element: 'Sn', orbital: '5p3/2', be: 1 },
  { element: 'Sb', orbital: '5p3/2', be: 2 },
  { element: 'Te', orbital: '5p3/2', be: 2 },
  { element: 'I', orbital: '5p3/2', be: 3 },
  { element: 'Xe', orbital: '5p3/2', be: 7 },
  { element: 'Cs', orbital: '5p3/2', be: 12 },
  { element: 'Ba', orbital: '5p3/2', be: 15 },
  { element: 'La', orbital: '5p3/2', be: 15 },
  { element: 'Ce', orbital: '5p3/2', be: 20 },
  { element: 'Pr', orbital: '5p3/2', be: 23 },
  { element: 'Nd', orbital: '5p3/2', be: 22 },
  { element: 'Pm', orbital: '5p3/2', be: 22 },
  { element: 'Sm', orbital: '5p3/2', be: 22 },
  { element: 'Eu', orbital: '5p3/2', be: 22 },
  { element: 'Gd', orbital: '5p3/2', be: 21 },
  { element: 'Tb', orbital: '5p3/2', be: 26 },
  { element: 'Dy', orbital: '5p3/2', be: 26 },
  { element: 'Ho', orbital: '5p3/2', be: 20 },
  { element: 'Er', orbital: '5p3/2', be: 29 },
  { element: 'Tm', orbital: '5p3/2', be: 32 },
  { element: 'Yb', orbital: '5p3/2', be: 23 },
  { element: 'Lu', orbital: '5p3/2', be: 28 },
  { element: 'Hf', orbital: '5p3/2', be: 31 },
  { element: 'Ta', orbital: '5p3/2', be: 37 },
  { element: 'W', orbital: '5p3/2', be: 37 },
  { element: 'Re', orbital: '5p3/2', be: 35 },
  { element: 'Os', orbital: '5p3/2', be: 46 },
  { element: 'Ir', orbital: '5p3/2', be: 51 },
  { element: 'Pt', orbital: '5p3/2', be: 51 },
  { element: 'Au', orbital: '5p3/2', be: 54 },
  { element: 'Hg', orbital: '5p3/2', be: 58 },
  { element: 'Tl', orbital: '5p3/2', be: 76 },
  { element: 'Pb', orbital: '5p3/2', be: 86 },
  { element: 'Bi', orbital: '5p3/2', be: 93 },
  { element: 'Po', orbital: '5p3/2', be: 104 },
  { element: 'At', orbital: '5p3/2', be: 115 },
  { element: 'Rn', orbital: '5p3/2', be: 127 },
  { element: 'Fr', orbital: '5p3/2', be: 140 },
  { element: 'Ra', orbital: '5p3/2', be: 153 },
  { element: 'Ac', orbital: '5p3/2', be: 167 },
  { element: 'Th', orbital: '5p3/2', be: 182 },
  { element: 'In', orbital: '5p', be: 1 },
  { element: 'Sn', orbital: '5p', be: 1 },
  { element: 'Sb', orbital: '5p', be: 2 },
  { element: 'Te', orbital: '5p', be: 2 },
  { element: 'I', orbital: '5p', be: 3 },
  { element: 'Xe', orbital: '5p', be: 7 },
  { element: 'Cs', orbital: '5p', be: 12 },
  { element: 'Ba', orbital: '5p', be: 15 },
  { element: 'La', orbital: '5p', be: 15 },
  { element: 'Ce', orbital: '5p', be: 20 },
  { element: 'Pr', orbital: '5p', be: 23 },
  { element: 'Nd', orbital: '5p', be: 22 },
  { element: 'Pm', orbital: '5p', be: 22 },
  { element: 'Sm', orbital: '5p', be: 22 },
  { element: 'Eu', orbital: '5p', be: 22 },
  { element: 'Gd', orbital: '5p', be: 21 },
  { element: 'Tb', orbital: '5p', be: 26 },
  { element: 'Dy', orbital: '5p', be: 26 },
  { element: 'Ho', orbital: '5p', be: 20 },
  { element: 'Er', orbital: '5p', be: 29 },
  { element: 'Tm', orbital: '5p', be: 32 },
  { element: 'Yb', orbital: '5p', be: 23 },
  { element: 'Lu', orbital: '5p', be: 28 },
  { element: 'Hf', orbital: '5p', be: 31 },
  { element: 'Ta', orbital: '5p', be: 37 },
  { element: 'W', orbital: '5p', be: 37 },
  { element: 'Re', orbital: '5p', be: 35 },
  { element: 'Os', orbital: '5p', be: 46 },
  { element: 'Ir', orbital: '5p', be: 51 },
  { element: 'Pt', orbital: '5p', be: 51 },
  { element: 'Au', orbital: '5p', be: 54 },
  { element: 'Hg', orbital: '5p', be: 58 },
  { element: 'Tl', orbital: '5p', be: 76 },
  { element: 'Pb', orbital: '5p', be: 86 },
  { element: 'Bi', orbital: '5p', be: 93 },
  { element: 'Po', orbital: '5p', be: 104 },
  { element: 'At', orbital: '5p', be: 115 },
  { element: 'Rn', orbital: '5p', be: 127 },
  { element: 'Fr', orbital: '5p', be: 140 },
  { element: 'Ra', orbital: '5p', be: 153 },
  { element: 'Ac', orbital: '5p', be: 167 },
  { element: 'Th', orbital: '5p', be: 182 },
  { element: 'Lu', orbital: '5d3/2', be: 5 },
  { element: 'Hf', orbital: '5d3/2', be: 7 },
  { element: 'Ta', orbital: '5d3/2', be: 6 },
  { element: 'W', orbital: '5d3/2', be: 6 },
  { element: 'Re', orbital: '5d3/2', be: 4 },
  { element: 'Ir', orbital: '5d3/2', be: 4 },
  { element: 'Pt', orbital: '5d3/2', be: 2 },
  { element: 'Au', orbital: '5d3/2', be: 3 },
  { element: 'Hg', orbital: '5d3/2', be: 7 },
  { element: 'Tl', orbital: '5d3/2', be: 16 },
  { element: 'Pb', orbital: '5d3/2', be: 22 },
  { element: 'Bi', orbital: '5d3/2', be: 27 },
  { element: 'Po', orbital: '5d3/2', be: 31 },
  { element: 'At', orbital: '5d3/2', be: 40 },
  { element: 'Rn', orbital: '5d3/2', be: 48 },
  { element: 'Fr', orbital: '5d3/2', be: 58 },
  { element: 'Ra', orbital: '5d3/2', be: 68 },
  { element: 'Ac', orbital: '5d3/2', be: 80 },
  { element: 'Th', orbital: '5d3/2', be: 95 },
  { element: 'U', orbital: '5d3/2', be: 104 },
  { element: 'Lu', orbital: '5d5/2', be: 5 },
  { element: 'Hf', orbital: '5d5/2', be: 7 },
  { element: 'Ta', orbital: '5d5/2', be: 6 },
  { element: 'W', orbital: '5d5/2', be: 6 },
  { element: 'Re', orbital: '5d5/2', be: 4 },
  { element: 'Ir', orbital: '5d5/2', be: 4 },
  { element: 'Pt', orbital: '5d5/2', be: 2 },
  { element: 'Au', orbital: '5d5/2', be: 3 },
  { element: 'Hg', orbital: '5d5/2', be: 7 },
  { element: 'Tl', orbital: '5d5/2', be: 13 },
  { element: 'Pb', orbital: '5d5/2', be: 20 },
  { element: 'Bi', orbital: '5d5/2', be: 25 },
  { element: 'Po', orbital: '5d5/2', be: 31 },
  { element: 'At', orbital: '5d5/2', be: 40 },
  { element: 'Rn', orbital: '5d5/2', be: 48 },
  { element: 'Fr', orbital: '5d5/2', be: 58 },
  { element: 'Ra', orbital: '5d5/2', be: 68 },
  { element: 'Ac', orbital: '5d5/2', be: 80 },
  { element: 'Th', orbital: '5d5/2', be: 88 },
  { element: 'U', orbital: '5d5/2', be: 96 },
  { element: 'Lu', orbital: '5d', be: 5 },
  { element: 'Hf', orbital: '5d', be: 7 },
  { element: 'Ta', orbital: '5d', be: 6 },
  { element: 'W', orbital: '5d', be: 6 },
  { element: 'Re', orbital: '5d', be: 4 },
  { element: 'Ir', orbital: '5d', be: 4 },
  { element: 'Pt', orbital: '5d', be: 2 },
  { element: 'Au', orbital: '5d', be: 3 },
  { element: 'Hg', orbital: '5d', be: 7 },
  { element: 'Tl', orbital: '5d', be: 13 },
  { element: 'Pb', orbital: '5d', be: 20 },
  { element: 'Bi', orbital: '5d', be: 25 },
  { element: 'Po', orbital: '5d', be: 31 },
  { element: 'At', orbital: '5d', be: 40 },
  { element: 'Rn', orbital: '5d', be: 48 },
  { element: 'Fr', orbital: '5d', be: 58 },
  { element: 'Ra', orbital: '5d', be: 68 },
  { element: 'Ac', orbital: '5d', be: 80 },
  { element: 'Th', orbital: '5d', be: 88 },
  { element: 'U', orbital: '5d', be: 96 },
  { element: 'Pb', orbital: '6s', be: 3 },
  { element: 'Bi', orbital: '6s', be: 8 },
  { element: 'Po', orbital: '6s', be: 12 },
  { element: 'At', orbital: '6s', be: 18 },
  { element: 'Rn', orbital: '6s', be: 26 },
  { element: 'Fr', orbital: '6s', be: 34 },
  { element: 'Ra', orbital: '6s', be: 44 },
  { element: 'Th', orbital: '6s', be: 60 },
  { element: 'Pb', orbital: '6p1/2', be: 1 },
  { element: 'Bi', orbital: '6p1/2', be: 3 },
  { element: 'Po', orbital: '6p1/2', be: 5 },
  { element: 'At', orbital: '6p1/2', be: 8 },
  { element: 'Rn', orbital: '6p1/2', be: 11 },
  { element: 'Fr', orbital: '6p1/2', be: 15 },
  { element: 'Ra', orbital: '6p1/2', be: 19 },
  { element: 'Th', orbital: '6p1/2', be: 49 },
  { element: 'U', orbital: '6p1/2', be: 28.9 },
  { element: 'Pb', orbital: '6p3/2', be: 1 },
  { element: 'Bi', orbital: '6p3/2', be: 3 },
  { element: 'Po', orbital: '6p3/2', be: 5 },
  { element: 'At', orbital: '6p3/2', be: 8 },
  { element: 'Rn', orbital: '6p3/2', be: 11 },
  { element: 'Fr', orbital: '6p3/2', be: 15 },
  { element: 'Ra', orbital: '6p3/2', be: 19 },
  { element: 'Th', orbital: '6p3/2', be: 43 },
  { element: 'U', orbital: '6p3/2', be: 19 },
  { element: 'Pb', orbital: '6p', be: 1 },
  { element: 'Bi', orbital: '6p', be: 3 },
  { element: 'Po', orbital: '6p', be: 5 },
  { element: 'At', orbital: '6p', be: 8 },
  { element: 'Rn', orbital: '6p', be: 11 },
  { element: 'Fr', orbital: '6p', be: 15 },
  { element: 'Ra', orbital: '6p', be: 19 },
  { element: 'Th', orbital: '6p', be: 43 },
  { element: 'U', orbital: '6p', be: 19 },
  { element: 'H', orbital: '1s', be: 14 },
  { element: 'He', orbital: '1s', be: 25 },
  { element: 'Li', orbital: '1s', be: 55 },
  { element: 'Be', orbital: '1s', be: 111 },
  { element: 'B', orbital: '1s', be: 188 },
  { element: 'C', orbital: '1s', be: 284 },
  { element: 'N', orbital: '1s', be: 399 },
  { element: 'O', orbital: '1s', be: 532 },
  { element: 'F', orbital: '1s', be: 686 },
  { element: 'Ne', orbital: '1s', be: 867 },
  { element: 'Na', orbital: '1s', be: 1072 },
  { element: 'O', orbital: '2s', be: 24 },
  { element: 'F', orbital: '2s', be: 31 },
  { element: 'Ne', orbital: '2s', be: 45 },
  { element: 'Na', orbital: '2s', be: 63 },
  { element: 'Mg', orbital: '2s', be: 89 },
  { element: 'Al', orbital: '2s', be: 118 },
  { element: 'Si', orbital: '2s', be: 149 },
  { element: 'P', orbital: '2s', be: 189 },
  { element: 'S', orbital: '2s', be: 229 },
  { element: 'Cl', orbital: '2s', be: 270 },
  { element: 'Ar', orbital: '2s', be: 320 },
  { element: 'K', orbital: '2s', be: 377 },
  { element: 'Ca', orbital: '2s', be: 438 },
  { element: 'Sc', orbital: '2s', be: 500 },
  { element: 'Ti', orbital: '2s', be: 564 },
  { element: 'V', orbital: '2s', be: 628 },
  { element: 'Cr', orbital: '2s', be: 695 },
  { element: 'Mn', orbital: '2s', be: 769 },
  { element: 'Fe', orbital: '2s', be: 846 },
  { element: 'Co', orbital: '2s', be: 926 },
  { element: 'Ni', orbital: '2s', be: 1008 },
  { element: 'Cu', orbital: '2s', be: 1096 },
  { element: 'Zn', orbital: '2s', be: 1194 },
  { element: 'B', orbital: '2p1/2', be: 5 },
  { element: 'C', orbital: '2p1/2', be: 7 },
  { element: 'N', orbital: '2p1/2', be: 9 },
  { element: 'O', orbital: '2p1/2', be: 7 },
  { element: 'F', orbital: '2p1/2', be: 9 },
  { element: 'Ne', orbital: '2p1/2', be: 18 },
  { element: 'Na', orbital: '2p1/2', be: 31 },
  { element: 'Mg', orbital: '2p1/2', be: 52 },
  { element: 'Al', orbital: '2p1/2', be: 74 },
  { element: 'Si', orbital: '2p1/2', be: 100 },
  { element: 'P', orbital: '2p1/2', be: 136 },
  { element: 'S', orbital: '2p1/2', be: 165 },
  { element: 'Cl', orbital: '2p1/2', be: 202 },
  { element: 'Ar', orbital: '2p1/2', be: 247 },
  { element: 'K', orbital: '2p1/2', be: 297 },
  { element: 'Ca', orbital: '2p1/2', be: 350 },
  { element: 'Sc', orbital: '2p1/2', be: 407 },
  { element: 'Ti', orbital: '2p1/2', be: 461 },
  { element: 'V', orbital: '2p1/2', be: 520 },
  { element: 'Cr', orbital: '2p1/2', be: 584 },
  { element: 'Mn', orbital: '2p1/2', be: 652 },
  { element: 'Fe', orbital: '2p1/2', be: 723 },
  { element: 'Co', orbital: '2p1/2', be: 794 },
  { element: 'Ni', orbital: '2p1/2', be: 872 },
  { element: 'Cu', orbital: '2p1/2', be: 951 },
  { element: 'Zn', orbital: '2p1/2', be: 1044 },
  { element: 'Ga', orbital: '2p1/2', be: 1143 },
  { element: 'B', orbital: '2p3/2', be: 5 },
  { element: 'C', orbital: '2p3/2', be: 7 },
  { element: 'N', orbital: '2p3/2', be: 9 },
  { element: 'O', orbital: '2p3/2', be: 7 },
  { element: 'F', orbital: '2p3/2', be: 9 },
  { element: 'Ne', orbital: '2p3/2', be: 18 },
  { element: 'Na', orbital: '2p3/2', be: 31 },
  { element: 'Mg', orbital: '2p3/2', be: 52 },
  { element: 'Al', orbital: '2p3/2', be: 73 },
  { element: 'Si', orbital: '2p3/2', be: 99 },
  { element: 'P', orbital: '2p3/2', be: 135 },
  { element: 'S', orbital: '2p3/2', be: 164 },
  { element: 'Cl', orbital: '2p3/2', be: 200 },
  { element: 'Ar', orbital: '2p3/2', be: 245 },
  { element: 'K', orbital: '2p3/2', be: 294 },
  { element: 'Ca', orbital: '2p3/2', be: 347 },
  { element: 'Sc', orbital: '2p3/2', be: 402 },
  { element: 'Ti', orbital: '2p3/2', be: 455 },
  { element: 'V', orbital: '2p3/2', be: 513 },
  { element: 'Cr', orbital: '2p3/2', be: 575 },
  { element: 'Mn', orbital: '2p3/2', be: 641 },
  { element: 'Fe', orbital: '2p3/2', be: 710 },
  { element: 'Co', orbital: '2p3/2', be: 779 },
  { element: 'Ni', orbital: '2p3/2', be: 855 },
  { element: 'Cu', orbital: '2p3/2', be: 931 },
  { element: 'Zn', orbital: '2p3/2', be: 1021 },
  { element: 'Ga', orbital: '2p3/2', be: 1116 },
  { element: 'Ge', orbital: '2p3/2', be: 1217 },
  { element: 'B', orbital: '2p', be: 5 },
  { element: 'C', orbital: '2p', be: 7 },
  { element: 'N', orbital: '2p', be: 9 },
  { element: 'O', orbital: '2p', be: 7 },
  { element: 'F', orbital: '2p', be: 9 },
  { element: 'Ne', orbital: '2p', be: 18 },
  { element: 'Na', orbital: '2p', be: 31 },
  { element: 'Mg', orbital: '2p', be: 52 },
  { element: 'Al', orbital: '2p', be: 73 },
  { element: 'Si', orbital: '2p', be: 99 },
  { element: 'P', orbital: '2p', be: 135 },
  { element: 'S', orbital: '2p', be: 164 },
  { element: 'Cl', orbital: '2p', be: 200 },
  { element: 'Ar', orbital: '2p', be: 245 },
  { element: 'K', orbital: '2p', be: 294 },
  { element: 'Ca', orbital: '2p', be: 347 },
  { element: 'Sc', orbital: '2p', be: 402 },
  { element: 'Ti', orbital: '2p', be: 455 },
  { element: 'V', orbital: '2p', be: 513 },
  { element: 'Cr', orbital: '2p', be: 575 },
  { element: 'Mn', orbital: '2p', be: 641 },
  { element: 'Fe', orbital: '2p', be: 710 },
  { element: 'Co', orbital: '2p', be: 779 },
  { element: 'Ni', orbital: '2p', be: 855 },
  { element: 'Cu', orbital: '2p', be: 931 },
  { element: 'Zn', orbital: '2p', be: 1021 },
  { element: 'Ga', orbital: '2p', be: 1116 },
  { element: 'Ge', orbital: '2p', be: 1217 },
  { element: 'Na', orbital: '3s', be: 1 },
  { element: 'Mg', orbital: '3s', be: 2 },
  { element: 'Al', orbital: '3s', be: 1 },
  { element: 'Si', orbital: '3s', be: 8 },
  { element: 'P', orbital: '3s', be: 16 },
  { element: 'S', orbital: '3s', be: 16 },
  { element: 'Cl', orbital: '3s', be: 18 },
  { element: 'Ar', orbital: '3s', be: 25 },
  { element: 'K', orbital: '3s', be: 34 },
  { element: 'Ca', orbital: '3s', be: 44 },
  { element: 'Sc', orbital: '3s', be: 54 },
  { element: 'Ti', orbital: '3s', be: 59 },
  { element: 'V', orbital: '3s', be: 66 },
  { element: 'Cr', orbital: '3s', be: 74 },
  { element: 'Mn', orbital: '3s', be: 84 },
  { element: 'Fe', orbital: '3s', be: 95 },
  { element: 'Co', orbital: '3s', be: 101 },
  { element: 'Ni', orbital: '3s', be: 112 },
  { element: 'Cu', orbital: '3s', be: 120 },
  { element: 'Zn', orbital: '3s', be: 137 },
  { element: 'Ga', orbital: '3s', be: 158 },
  { element: 'Ge', orbital: '3s', be: 181 },
  { element: 'As', orbital: '3s', be: 204 },
  { element: 'Se', orbital: '3s', be: 232 },
  { element: 'Br', orbital: '3s', be: 257 },
  { element: 'Kr', orbital: '3s', be: 289 },
  { element: 'Rb', orbital: '3s', be: 322 },
  { element: 'Sr', orbital: '3s', be: 358 },
  { element: 'Y', orbital: '3s', be: 395 },
  { element: 'Zr', orbital: '3s', be: 431 },
  { element: 'Nb', orbital: '3s', be: 469 },
  { element: 'Mo', orbital: '3s', be: 505 },
  { element: 'Tc', orbital: '3s', be: 544 },
  { element: 'Ru', orbital: '3s', be: 585 },
  { element: 'Rh', orbital: '3s', be: 627 },
  { element: 'Pd', orbital: '3s', be: 670 },
  { element: 'Ag', orbital: '3s', be: 717 },
  { element: 'Cd', orbital: '3s', be: 770 },
  { element: 'In', orbital: '3s', be: 826 },
  { element: 'Sn', orbital: '3s', be: 884 },
  { element: 'Sb', orbital: '3s', be: 944 },
  { element: 'Te', orbital: '3s', be: 1006 },
  { element: 'I', orbital: '3s', be: 1072 },
  { element: 'Xe', orbital: '3s', be: 1145 },
  { element: 'Cs', orbital: '3s', be: 1217 },
  { element: 'Si', orbital: '3p1/2', be: 3 },
  { element: 'P', orbital: '3p1/2', be: 10 },
  { element: 'S', orbital: '3p1/2', be: 8 },
  { element: 'Cl', orbital: '3p1/2', be: 7 },
  { element: 'Ar', orbital: '3p1/2', be: 12 },
  { element: 'K', orbital: '3p1/2', be: 18 },
  { element: 'Ca', orbital: '3p1/2', be: 26 },
  { element: 'Sc', orbital: '3p1/2', be: 32 },
  { element: 'Ti', orbital: '3p1/2', be: 34 },
  { element: 'V', orbital: '3p1/2', be: 38 },
  { element: 'Cr', orbital: '3p1/2', be: 43 },
  { element: 'Mn', orbital: '3p1/2', be: 49 },
  { element: 'Fe', orbital: '3p1/2', be: 56 },
  { element: 'Co', orbital: '3p1/2', be: 60 },
  { element: 'Ni', orbital: '3p1/2', be: 68 },
  { element: 'Cu', orbital: '3p1/2', be: 74 },
  { element: 'Zn', orbital: '3p1/2', be: 87 },
  { element: 'Ga', orbital: '3p1/2', be: 107 },
  { element: 'Ge', orbital: '3p1/2', be: 129 },
  { element: 'As', orbital: '3p1/2', be: 147 },
  { element: 'Se', orbital: '3p1/2', be: 168 },
  { element: 'Br', orbital: '3p1/2', be: 189 },
  { element: 'Kr', orbital: '3p1/2', be: 223 },
  { element: 'Rb', orbital: '3p1/2', be: 248 },
  { element: 'Sr', orbital: '3p1/2', be: 280 },
  { element: 'Y', orbital: '3p1/2', be: 313 },
  { element: 'Zr', orbital: '3p1/2', be: 345 },
  { element: 'Nb', orbital: '3p1/2', be: 379 },
  { element: 'Mo', orbital: '3p1/2', be: 410 },
  { element: 'Tc', orbital: '3p1/2', be: 445 },
  { element: 'Ru', orbital: '3p1/2', be: 483 },
  { element: 'Rh', orbital: '3p1/2', be: 521 },
  { element: 'Pd', orbital: '3p1/2', be: 559 },
  { element: 'Ag', orbital: '3p1/2', be: 602 },
  { element: 'Cd', orbital: '3p1/2', be: 651 },
  { element: 'In', orbital: '3p1/2', be: 702 },
  { element: 'Sn', orbital: '3p1/2', be: 757 },
  { element: 'Sb', orbital: '3p1/2', be: 812 },
  { element: 'Te', orbital: '3p1/2', be: 870 },
  { element: 'I', orbital: '3p1/2', be: 931 },
  { element: 'Xe', orbital: '3p1/2', be: 999 },
  { element: 'Cs', orbital: '3p1/2', be: 1065 },
  { element: 'Ba', orbital: '3p1/2', be: 1137 },
  { element: 'La', orbital: '3p1/2', be: 1205 },
  { element: 'Si', orbital: '3p3/2', be: 3 },
  { element: 'P', orbital: '3p3/2', be: 10 },
  { element: 'S', orbital: '3p3/2', be: 8 },
  { element: 'Cl', orbital: '3p3/2', be: 7 },
  { element: 'Ar', orbital: '3p3/2', be: 12 },
  { element: 'K', orbital: '3p3/2', be: 18 },
  { element: 'Ca', orbital: '3p3/2', be: 26 },
  { element: 'Sc', orbital: '3p3/2', be: 32 },
  { element: 'Ti', orbital: '3p3/2', be: 34 },
  { element: 'V', orbital: '3p3/2', be: 38 },
  { element: 'Cr', orbital: '3p3/2', be: 43 },
  { element: 'Mn', orbital: '3p3/2', be: 49 },
  { element: 'Fe', orbital: '3p3/2', be: 56 },
  { element: 'Co', orbital: '3p3/2', be: 60 },
  { element: 'Ni', orbital: '3p3/2', be: 68 },
  { element: 'Cu', orbital: '3p3/2', be: 74 },
  { element: 'Zn', orbital: '3p3/2', be: 87 },
  { element: 'Ga', orbital: '3p3/2', be: 103 },
  { element: 'Ge', orbital: '3p3/2', be: 122 },
  { element: 'As', orbital: '3p3/2', be: 141 },
  { element: 'Se', orbital: '3p3/2', be: 162 },
  { element: 'Br', orbital: '3p3/2', be: 182 },
  { element: 'Kr', orbital: '3p3/2', be: 214 },
  { element: 'Rb', orbital: '3p3/2', be: 239 },
  { element: 'Sr', orbital: '3p3/2', be: 269 },
  { element: 'Y', orbital: '3p3/2', be: 301 },
  { element: 'Zr', orbital: '3p3/2', be: 331 },
  { element: 'Nb', orbital: '3p3/2', be: 363 },
  { element: 'Mo', orbital: '3p3/2', be: 393 },
  { element: 'Tc', orbital: '3p3/2', be: 425 },
  { element: 'Ru', orbital: '3p3/2', be: 461 },
  { element: 'Rh', orbital: '3p3/2', be: 496 },
  { element: 'Pd', orbital: '3p3/2', be: 531 },
  { element: 'Ag', orbital: '3p3/2', be: 571 },
  { element: 'Cd', orbital: '3p3/2', be: 617 },
  { element: 'In', orbital: '3p3/2', be: 664 },
  { element: 'Sn', orbital: '3p3/2', be: 715 },
  { element: 'Sb', orbital: '3p3/2', be: 766 },
  { element: 'Te', orbital: '3p3/2', be: 819 },
  { element: 'I', orbital: '3p3/2', be: 875 },
  { element: 'Xe', orbital: '3p3/2', be: 937 },
  { element: 'Cs', orbital: '3p3/2', be: 998 },
  { element: 'Ba', orbital: '3p3/2', be: 1063 },
  { element: 'La', orbital: '3p3/2', be: 1124 },
  { element: 'Ce', orbital: '3p3/2', be: 1186 },
  { element: 'Pr', orbital: '3p3/2', be: 1243 },
  { element: 'Si', orbital: '3p', be: 3 },
  { element: 'P', orbital: '3p', be: 10 },
  { element: 'S', orbital: '3p', be: 8 },
  { element: 'Cl', orbital: '3p', be: 7 },
  { element: 'Ar', orbital: '3p', be: 12 },
  { element: 'K', orbital: '3p', be: 18 },
  { element: 'Ca', orbital: '3p', be: 26 },
  { element: 'Sc', orbital: '3p', be: 32 },
  { element: 'Ti', orbital: '3p', be: 34 },
  { element: 'V', orbital: '3p', be: 38 },
  { element: 'Cr', orbital: '3p', be: 43 },
  { element: 'Mn', orbital: '3p', be: 49 },
  { element: 'Fe', orbital: '3p', be: 56 },
  { element: 'Co', orbital: '3p', be: 60 },
  { element: 'Ni', orbital: '3p', be: 68 },
  { element: 'Cu', orbital: '3p', be: 74 },
  { element: 'Zn', orbital: '3p', be: 87 },
  { element: 'Ga', orbital: '3p', be: 103 },
  { element: 'Ge', orbital: '3p', be: 122 },
  { element: 'As', orbital: '3p', be: 141 },
  { element: 'Se', orbital: '3p', be: 162 },
  { element: 'Br', orbital: '3p', be: 182 },
  { element: 'Kr', orbital: '3p', be: 214 },
  { element: 'Rb', orbital: '3p', be: 239 },
  { element: 'Sr', orbital: '3p', be: 269 },
  { element: 'Y', orbital: '3p', be: 301 },
  { element: 'Zr', orbital: '3p', be: 331 },
  { element: 'Nb', orbital: '3p', be: 363 },
  { element: 'Mo', orbital: '3p', be: 393 },
  { element: 'Tc', orbital: '3p', be: 425 },
  { element: 'Ru', orbital: '3p', be: 461 },
  { element: 'Rh', orbital: '3p', be: 496 },
  { element: 'Pd', orbital: '3p', be: 531 },
  { element: 'Ag', orbital: '3p', be: 571 },
  { element: 'Cd', orbital: '3p', be: 617 },
  { element: 'In', orbital: '3p', be: 664 },
  { element: 'Sn', orbital: '3p', be: 715 },
  { element: 'Sb', orbital: '3p', be: 766 },
  { element: 'Te', orbital: '3p', be: 819 },
  { element: 'I', orbital: '3p', be: 875 },
  { element: 'Xe', orbital: '3p', be: 937 },
  { element: 'Cs', orbital: '3p', be: 998 },
  { element: 'Ba', orbital: '3p', be: 1063 },
  { element: 'La', orbital: '3p', be: 1124 },
  { element: 'Ce', orbital: '3p', be: 1186 },
  { element: 'Pr', orbital: '3p', be: 1243 },
  { element: 'Sc', orbital: '3d3/2', be: 7 },
  { element: 'Ti', orbital: '3d3/2', be: 3 },
  { element: 'V', orbital: '3d3/2', be: 2 },
  { element: 'Cr', orbital: '3d3/2', be: 2 },
  { element: 'Mn', orbital: '3d3/2', be: 4 },
  { element: 'Fe', orbital: '3d3/2', be: 6 },
  { element: 'Co', orbital: '3d3/2', be: 3 },
  { element: 'Ni', orbital: '3d3/2', be: 4 },
  { element: 'Cu', orbital: '3d3/2', be: 2 },
  { element: 'Zn', orbital: '3d3/2', be: 9 },
  { element: 'Ga', orbital: '3d3/2', be: 18 },
  { element: 'Ge', orbital: '3d3/2', be: 29 },
  { element: 'As', orbital: '3d3/2', be: 41 },
  { element: 'Se', orbital: '3d3/2', be: 57 },
  { element: 'Br', orbital: '3d3/2', be: 70 },
  { element: 'Kr', orbital: '3d3/2', be: 89 },
  { element: 'Rb', orbital: '3d3/2', be: 112 },
  { element: 'Sr', orbital: '3d3/2', be: 135 },
  { element: 'Y', orbital: '3d3/2', be: 160 },
  { element: 'Zr', orbital: '3d3/2', be: 183 },
  { element: 'Nb', orbital: '3d3/2', be: 208 },
  { element: 'Mo', orbital: '3d3/2', be: 230 },
  { element: 'Tc', orbital: '3d3/2', be: 257 },
  { element: 'Ru', orbital: '3d3/2', be: 284 },
  { element: 'Rh', orbital: '3d3/2', be: 312 },
  { element: 'Pd', orbital: '3d3/2', be: 340 },
  { element: 'Ag', orbital: '3d3/2', be: 373 },
  { element: 'Cd', orbital: '3d3/2', be: 411 },
  { element: 'In', orbital: '3d3/2', be: 451 },
  { element: 'Sn', orbital: '3d3/2', be: 494 },
  { element: 'Sb', orbital: '3d3/2', be: 537 },
  { element: 'Te', orbital: '3d3/2', be: 582 },
  { element: 'I', orbital: '3d3/2', be: 631 },
  { element: 'Xe', orbital: '3d3/2', be: 685 },
  { element: 'Cs', orbital: '3d3/2', be: 740 },
  { element: 'Ba', orbital: '3d3/2', be: 796 },
  { element: 'La', orbital: '3d3/2', be: 849 },
  { element: 'Ce', orbital: '3d3/2', be: 902 },
  { element: 'Pr', orbital: '3d3/2', be: 951 },
  { element: 'Nd', orbital: '3d3/2', be: 1000 },
  { element: 'Pm', orbital: '3d3/2', be: 1052 },
  { element: 'Sm', orbital: '3d3/2', be: 1107 },
  { element: 'Eu', orbital: '3d3/2', be: 1161 },
  { element: 'Gd', orbital: '3d3/2', be: 1218 },
  { element: 'Sc', orbital: '3d5/2', be: 7 },
  { element: 'Ti', orbital: '3d5/2', be: 3 },
  { element: 'V', orbital: '3d5/2', be: 2 },
  { element: 'Cr', orbital: '3d5/2', be: 2 },
  { element: 'Mn', orbital: '3d5/2', be: 4 },
  { element: 'Fe', orbital: '3d5/2', be: 6 },
  { element: 'Co', orbital: '3d5/2', be: 3 },
  { element: 'Ni', orbital: '3d5/2', be: 4 },
  { element: 'Cu', orbital: '3d5/2', be: 2 },
  { element: 'Zn', orbital: '3d5/2', be: 9 },
  { element: 'Ga', orbital: '3d5/2', be: 18 },
  { element: 'Ge', orbital: '3d5/2', be: 29 },
  { element: 'As', orbital: '3d5/2', be: 41 },
  { element: 'Se', orbital: '3d5/2', be: 57 },
  { element: 'Br', orbital: '3d5/2', be: 69 },
  { element: 'Kr', orbital: '3d5/2', be: 89 },
  { element: 'Rb', orbital: '3d5/2', be: 111 },
  { element: 'Sr', orbital: '3d5/2', be: 133 },
  { element: 'Y', orbital: '3d5/2', be: 158 },
  { element: 'Zr', orbital: '3d5/2', be: 180 },
  { element: 'Nb', orbital: '3d5/2', be: 205 },
  { element: 'Mo', orbital: '3d5/2', be: 227 },
  { element: 'Tc', orbital: '3d5/2', be: 253 },
  { element: 'Ru', orbital: '3d5/2', be: 279 },
  { element: 'Rh', orbital: '3d5/2', be: 307 },
  { element: 'Pd', orbital: '3d5/2', be: 335 },
  { element: 'Ag', orbital: '3d5/2', be: 367 },
  { element: 'Cd', orbital: '3d5/2', be: 404 },
  { element: 'In', orbital: '3d5/2', be: 443 },
  { element: 'Sn', orbital: '3d5/2', be: 485 },
  { element: 'Sb', orbital: '3d5/2', be: 528 },
  { element: 'Te', orbital: '3d5/2', be: 572 },
  { element: 'I', orbital: '3d5/2', be: 620 },
  { element: 'Xe', orbital: '3d5/2', be: 672 },
  { element: 'Cs', orbital: '3d5/2', be: 726 },
  { element: 'Ba', orbital: '3d5/2', be: 781 },
  { element: 'La', orbital: '3d5/2', be: 832 },
  { element: 'Ce', orbital: '3d5/2', be: 884 },
  { element: 'Pr', orbital: '3d5/2', be: 931 },
  { element: 'Nd', orbital: '3d5/2', be: 978 },
  { element: 'Pm', orbital: '3d5/2', be: 1027 },
  { element: 'Sm', orbital: '3d5/2', be: 1081 },
  { element: 'Eu', orbital: '3d5/2', be: 1131 },
  { element: 'Gd', orbital: '3d5/2', be: 1186 },
  { element: 'Tb', orbital: '3d5/2', be: 1242 },
  { element: 'Sc', orbital: '3d', be: 7 },
  { element: 'Ti', orbital: '3d', be: 3 },
  { element: 'V', orbital: '3d', be: 2 },
  { element: 'Cr', orbital: '3d', be: 2 },
  { element: 'Mn', orbital: '3d', be: 4 },
  { element: 'Fe', orbital: '3d', be: 6 },
  { element: 'Co', orbital: '3d', be: 3 },
  { element: 'Ni', orbital: '3d', be: 4 },
  { element: 'Cu', orbital: '3d', be: 2 },
  { element: 'Zn', orbital: '3d', be: 9 },
  { element: 'Ga', orbital: '3d', be: 18 },
  { element: 'Ge', orbital: '3d', be: 29 },
  { element: 'As', orbital: '3d', be: 41 },
  { element: 'Se', orbital: '3d', be: 57 },
  { element: 'Br', orbital: '3d', be: 69 },
  { element: 'Kr', orbital: '3d', be: 89 },
  { element: 'Rb', orbital: '3d', be: 111 },
  { element: 'Sr', orbital: '3d', be: 133 },
  { element: 'Y', orbital: '3d', be: 158 },
  { element: 'Zr', orbital: '3d', be: 180 },
  { element: 'Nb', orbital: '3d', be: 205 },
  { element: 'Mo', orbital: '3d', be: 227 },
  { element: 'Tc', orbital: '3d', be: 253 },
  { element: 'Ru', orbital: '3d', be: 279 },
  { element: 'Rh', orbital: '3d', be: 307 },
  { element: 'Pd', orbital: '3d', be: 335 },
  { element: 'Ag', orbital: '3d', be: 367 },
  { element: 'Cd', orbital: '3d', be: 404 },
  { element: 'In', orbital: '3d', be: 443 },
  { element: 'Sn', orbital: '3d', be: 485 },
  { element: 'Sb', orbital: '3d', be: 528 },
  { element: 'Te', orbital: '3d', be: 572 },
  { element: 'I', orbital: '3d', be: 620 },
  { element: 'Xe', orbital: '3d', be: 672 },
  { element: 'Cs', orbital: '3d', be: 726 },
  { element: 'Ba', orbital: '3d', be: 781 },
  { element: 'La', orbital: '3d', be: 832 },
  { element: 'Ce', orbital: '3d', be: 884 },
  { element: 'Pr', orbital: '3d', be: 931 },
  { element: 'Nd', orbital: '3d', be: 978 },
  { element: 'Pm', orbital: '3d', be: 1027 },
  { element: 'Sm', orbital: '3d', be: 1081 },
  { element: 'Eu', orbital: '3d', be: 1131 },
  { element: 'Gd', orbital: '3d', be: 1186 },
  { element: 'Tb', orbital: '3d', be: 1242 },
  { element: 'Br', orbital: '4s', be: 27 },
  { element: 'Kr', orbital: '4s', be: 24 },
  { element: 'Rb', orbital: '4s', be: 30 },
  { element: 'Sr', orbital: '4s', be: 38 },
  { element: 'Y', orbital: '4s', be: 46 },
  { element: 'Zr', orbital: '4s', be: 52 },
  { element: 'Nb', orbital: '4s', be: 58 },
  { element: 'Mo', orbital: '4s', be: 62 },
  { element: 'Tc', orbital: '4s', be: 68 },
  { element: 'Ru', orbital: '4s', be: 75 },
  { element: 'Rh', orbital: '4s', be: 81 },
  { element: 'Pd', orbital: '4s', be: 86 },
  { element: 'Ag', orbital: '4s', be: 95 },
  { element: 'Cd', orbital: '4s', be: 108 },
  { element: 'In', orbital: '4s', be: 122 },
  { element: 'Sn', orbital: '4s', be: 137 },
  { element: 'Sb', orbital: '4s', be: 152 },
  { element: 'Te', orbital: '4s', be: 168 },
  { element: 'I', orbital: '4s', be: 186 },
  { element: 'Xe', orbital: '4s', be: 208 },
  { element: 'Cs', orbital: '4s', be: 231 },
  { element: 'Ba', orbital: '4s', be: 253 },
  { element: 'La', orbital: '4s', be: 271 },
  { element: 'Ce', orbital: '4s', be: 290 },
  { element: 'Pr', orbital: '4s', be: 305 },
  { element: 'Nd', orbital: '4s', be: 316 },
  { element: 'Pm', orbital: '4s', be: 331 },
  { element: 'Sm', orbital: '4s', be: 347 },
  { element: 'Eu', orbital: '4s', be: 360 },
  { element: 'Gd', orbital: '4s', be: 376 },
  { element: 'Tb', orbital: '4s', be: 398 },
  { element: 'Dy', orbital: '4s', be: 416 },
  { element: 'Ho', orbital: '4s', be: 436 },
  { element: 'Er', orbital: '4s', be: 449 },
  { element: 'Tm', orbital: '4s', be: 472 },
  { element: 'Yb', orbital: '4s', be: 487 },
  { element: 'Lu', orbital: '4s', be: 506 },
  { element: 'Hf', orbital: '4s', be: 538 },
  { element: 'Ta', orbital: '4s', be: 566 },
  { element: 'W', orbital: '4s', be: 595 },
  { element: 'Re', orbital: '4s', be: 625 },
  { element: 'Os', orbital: '4s', be: 655 },
  { element: 'Ir', orbital: '4s', be: 690 },
  { element: 'Pt', orbital: '4s', be: 724 },
  { element: 'Au', orbital: '4s', be: 759 },
  { element: 'Hg', orbital: '4s', be: 800 },
  { element: 'Tl', orbital: '4s', be: 846 },
  { element: 'Pb', orbital: '4s', be: 894 },
  { element: 'Bi', orbital: '4s', be: 939 },
  { element: 'Po', orbital: '4s', be: 995 },
  { element: 'At', orbital: '4s', be: 1042 },
  { element: 'Rn', orbital: '4s', be: 1097 },
  { element: 'Fr', orbital: '4s', be: 1153 },
  { element: 'Ra', orbital: '4s', be: 1208 },
  { element: 'Ga', orbital: '4p1/2', be: 1 },
  { element: 'Ge', orbital: '4p1/2', be: 3 },
  { element: 'As', orbital: '4p1/2', be: 3 },
  { element: 'Se', orbital: '4p1/2', be: 6 },
  { element: 'Br', orbital: '4p1/2', be: 5 },
  { element: 'Kr', orbital: '4p1/2', be: 11 },
  { element: 'Rb', orbital: '4p1/2', be: 15 },
  { element: 'Sr', orbital: '4p1/2', be: 20 },
  { element: 'Y', orbital: '4p1/2', be: 26 },
  { element: 'Zr', orbital: '4p1/2', be: 29 },
  { element: 'Nb', orbital: '4p1/2', be: 34 },
  { element: 'Mo', orbital: '4p1/2', be: 35 },
  { element: 'Tc', orbital: '4p1/2', be: 39 },
  { element: 'Ru', orbital: '4p1/2', be: 43 },
  { element: 'Rh', orbital: '4p1/2', be: 48 },
  { element: 'Pd', orbital: '4p1/2', be: 51 },
  { element: 'Ag', orbital: '4p1/2', be: 62 },
  { element: 'Cd', orbital: '4p1/2', be: 67 },
  { element: 'In', orbital: '4p1/2', be: 77 },
  { element: 'Sn', orbital: '4p1/2', be: 89 },
  { element: 'Sb', orbital: '4p1/2', be: 99 },
  { element: 'Te', orbital: '4p1/2', be: 110 },
  { element: 'I', orbital: '4p1/2', be: 123 },
  { element: 'Xe', orbital: '4p1/2', be: 147 },
  { element: 'Cs', orbital: '4p1/2', be: 172 },
  { element: 'Ba', orbital: '4p1/2', be: 192 },
  { element: 'La', orbital: '4p1/2', be: 206 },
  { element: 'Ce', orbital: '4p1/2', be: 224 },
  { element: 'Pr', orbital: '4p1/2', be: 237 },
  { element: 'Nd', orbital: '4p1/2', be: 244 },
  { element: 'Pm', orbital: '4p1/2', be: 255 },
  { element: 'Sm', orbital: '4p1/2', be: 267 },
  { element: 'Eu', orbital: '4p1/2', be: 284 },
  { element: 'Gd', orbital: '4p1/2', be: 289 },
  { element: 'Tb', orbital: '4p1/2', be: 311 },
  { element: 'Dy', orbital: '4p1/2', be: 332 },
  { element: 'Ho', orbital: '4p1/2', be: 343 },
  { element: 'Er', orbital: '4p1/2', be: 366 },
  { element: 'Tm', orbital: '4p1/2', be: 386 },
  { element: 'Yb', orbital: '4p1/2', be: 396 },
  { element: 'Lu', orbital: '4p1/2', be: 410 },
  { element: 'Hf', orbital: '4p1/2', be: 437 },
  { element: 'Ta', orbital: '4p1/2', be: 465 },
  { element: 'W', orbital: '4p1/2', be: 492 },
  { element: 'Re', orbital: '4p1/2', be: 518 },
  { element: 'Os', orbital: '4p1/2', be: 547 },
  { element: 'Ir', orbital: '4p1/2', be: 577 },
  { element: 'Pt', orbital: '4p1/2', be: 608 },
  { element: 'Au', orbital: '4p1/2', be: 644 },
  { element: 'Hg', orbital: '4p1/2', be: 677 },
  { element: 'Tl', orbital: '4p1/2', be: 722 },
  { element: 'Pb', orbital: '4p1/2', be: 764 },
  { element: 'Bi', orbital: '4p1/2', be: 806 },
  { element: 'Po', orbital: '4p1/2', be: 851 },
  { element: 'At', orbital: '4p1/2', be: 886 },
  { element: 'Rn', orbital: '4p1/2', be: 929 },
  { element: 'Fr', orbital: '4p1/2', be: 980 },
  { element: 'Ra', orbital: '4p1/2', be: 1058 },
  { element: 'Ac', orbital: '4p1/2', be: 1080 },
  { element: 'Th', orbital: '4p1/2', be: 1168 },
  { element: 'Ga', orbital: '4p3/2', be: 1 },
  { element: 'Ge', orbital: '4p3/2', be: 3 },
  { element: 'As', orbital: '4p3/2', be: 3 },
  { element: 'Se', orbital: '4p3/2', be: 6 },
  { element: 'Br', orbital: '4p3/2', be: 5 },
  { element: 'Kr', orbital: '4p3/2', be: 11 },
  { element: 'Rb', orbital: '4p3/2', be: 14 },
  { element: 'Sr', orbital: '4p3/2', be: 20 },
  { element: 'Y', orbital: '4p3/2', be: 26 },
  { element: 'Zr', orbital: '4p3/2', be: 29 },
  { element: 'Nb', orbital: '4p3/2', be: 34 },
  { element: 'Mo', orbital: '4p3/2', be: 35 },
  { element: 'Tc', orbital: '4p3/2', be: 39 },
  { element: 'Ru', orbital: '4p3/2', be: 43 },
  { element: 'Rh', orbital: '4p3/2', be: 48 },
  { element: 'Pd', orbital: '4p3/2', be: 56 },
  { element: 'Ag', orbital: '4p3/2', be: 56 },
  { element: 'Cd', orbital: '4p3/2', be: 67 },
  { element: 'In', orbital: '4p3/2', be: 77 },
  { element: 'Sn', orbital: '4p3/2', be: 89 },
  { element: 'Sb', orbital: '4p3/2', be: 99 },
  { element: 'Te', orbital: '4p3/2', be: 110 },
  { element: 'I', orbital: '4p3/2', be: 123 },
  { element: 'Xe', orbital: '4p3/2', be: 147 },
  { element: 'Cs', orbital: '4p3/2', be: 162 },
  { element: 'Ba', orbital: '4p3/2', be: 180 },
  { element: 'La', orbital: '4p3/2', be: 192 },
  { element: 'Ce', orbital: '4p3/2', be: 208 },
  { element: 'Pr', orbital: '4p3/2', be: 218 },
  { element: 'Nd', orbital: '4p3/2', be: 225 },
  { element: 'Pm', orbital: '4p3/2', be: 237 },
  { element: 'Sm', orbital: '4p3/2', be: 249 },
  { element: 'Eu', orbital: '4p3/2', be: 257 },
  { element: 'Gd', orbital: '4p3/2', be: 271 },
  { element: 'Tb', orbital: '4p3/2', be: 286 },
  { element: 'Dy', orbital: '4p3/2', be: 293 },
  { element: 'Ho', orbital: '4p3/2', be: 306 },
  { element: 'Er', orbital: '4p3/2', be: 320 },
  { element: 'Tm', orbital: '4p3/2', be: 337 },
  { element: 'Yb', orbital: '4p3/2', be: 343 },
  { element: 'Lu', orbital: '4p3/2', be: 359 },
  { element: 'Hf', orbital: '4p3/2', be: 380 },
  { element: 'Ta', orbital: '4p3/2', be: 405 },
  { element: 'W', orbital: '4p3/2', be: 426 },
  { element: 'Re', orbital: '4p3/2', be: 445 },
  { element: 'Os', orbital: '4p3/2', be: 469 },
  { element: 'Ir', orbital: '4p3/2', be: 495 },
  { element: 'Pt', orbital: '4p3/2', be: 519 },
  { element: 'Au', orbital: '4p3/2', be: 546 },
  { element: 'Hg', orbital: '4p3/2', be: 571 },
  { element: 'Tl', orbital: '4p3/2', be: 609 },
  { element: 'Pb', orbital: '4p3/2', be: 645 },
  { element: 'Bi', orbital: '4p3/2', be: 679 },
  { element: 'Po', orbital: '4p3/2', be: 705 },
  { element: 'At', orbital: '4p3/2', be: 740 },
  { element: 'Rn', orbital: '4p3/2', be: 768 },
  { element: 'Fr', orbital: '4p3/2', be: 810 },
  { element: 'Ra', orbital: '4p3/2', be: 879 },
  { element: 'Ac', orbital: '4p3/2', be: 890 },
  { element: 'Th', orbital: '4p3/2', be: 968 },
  { element: 'Ga', orbital: '4p', be: 1 },
  { element: 'Ge', orbital: '4p', be: 3 },
  { element: 'As', orbital: '4p', be: 3 },
  { element: 'Se', orbital: '4p', be: 6 },
  { element: 'Br', orbital: '4p', be: 5 },
  { element: 'Kr', orbital: '4p', be: 11 },
  { element: 'Rb', orbital: '4p', be: 14 },
  { element: 'Sr', orbital: '4p', be: 20 },
  { element: 'Y', orbital: '4p', be: 26 },
  { element: 'Zr', orbital: '4p', be: 29 },
  { element: 'Nb', orbital: '4p', be: 34 },
  { element: 'Mo', orbital: '4p', be: 35 },
  { element: 'Tc', orbital: '4p', be: 39 },
  { element: 'Ru', orbital: '4p', be: 43 },
  { element: 'Rh', orbital: '4p', be: 48 },
  { element: 'Pd', orbital: '4p', be: 56 },
  { element: 'Ag', orbital: '4p', be: 56 },
  { element: 'Cd', orbital: '4p', be: 67 },
  { element: 'In', orbital: '4p', be: 77 },
  { element: 'Sn', orbital: '4p', be: 89 },
  { element: 'Sb', orbital: '4p', be: 99 },
  { element: 'Te', orbital: '4p', be: 110 },
  { element: 'I', orbital: '4p', be: 123 },
  { element: 'Xe', orbital: '4p', be: 147 },
  { element: 'Cs', orbital: '4p', be: 162 },
  { element: 'Ba', orbital: '4p', be: 180 },
  { element: 'La', orbital: '4p', be: 192 },
  { element: 'Ce', orbital: '4p', be: 208 },
  { element: 'Pr', orbital: '4p', be: 218 },
  { element: 'Nd', orbital: '4p', be: 225 },
  { element: 'Pm', orbital: '4p', be: 237 },
  { element: 'Sm', orbital: '4p', be: 249 },
  { element: 'Eu', orbital: '4p', be: 257 },
  { element: 'Gd', orbital: '4p', be: 271 },
  { element: 'Tb', orbital: '4p', be: 286 },
  { element: 'Dy', orbital: '4p', be: 293 },
  { element: 'Ho', orbital: '4p', be: 306 },
  { element: 'Er', orbital: '4p', be: 320 },
  { element: 'Tm', orbital: '4p', be: 337 },
  { element: 'Yb', orbital: '4p', be: 343 },
  { element: 'Lu', orbital: '4p', be: 359 },
  { element: 'Hf', orbital: '4p', be: 380 },
  { element: 'Ta', orbital: '4p', be: 405 },
  { element: 'W', orbital: '4p', be: 426 },
  { element: 'Re', orbital: '4p', be: 445 },
  { element: 'Os', orbital: '4p', be: 469 },
  { element: 'Ir', orbital: '4p', be: 495 },
  { element: 'Pt', orbital: '4p', be: 519 },
  { element: 'Au', orbital: '4p', be: 546 },
  { element: 'Hg', orbital: '4p', be: 571 },
  { element: 'Tl', orbital: '4p', be: 609 },
  { element: 'Pb', orbital: '4p', be: 645 },
  { element: 'Bi', orbital: '4p', be: 679 },
  { element: 'Po', orbital: '4p', be: 705 },
  { element: 'At', orbital: '4p', be: 740 },
  { element: 'Rn', orbital: '4p', be: 768 },
  { element: 'Fr', orbital: '4p', be: 810 },
  { element: 'Ra', orbital: '4p', be: 879 },
  { element: 'Ac', orbital: '4p', be: 890 },
  { element: 'Th', orbital: '4p', be: 968 },
  { element: 'Y', orbital: '4d3/2', be: 3 },
  { element: 'Zr', orbital: '4d3/2', be: 3 },
  { element: 'Nb', orbital: '4d3/2', be: 4 },
  { element: 'Mo', orbital: '4d3/2', be: 2 },
  { element: 'Tc', orbital: '4d3/2', be: 2 },
  { element: 'Ru', orbital: '4d3/2', be: 2 },
  { element: 'Rh', orbital: '4d3/2', be: 3 },
  { element: 'Pd', orbital: '4d3/2', be: 1 },
  { element: 'Ag', orbital: '4d3/2', be: 3 },
  { element: 'Cd', orbital: '4d3/2', be: 9 },
  { element: 'In', orbital: '4d3/2', be: 16 },
  { element: 'Sn', orbital: '4d3/2', be: 24 },
  { element: 'Sb', orbital: '4d3/2', be: 32 },
  { element: 'Te', orbital: '4d3/2', be: 40 },
  { element: 'I', orbital: '4d3/2', be: 50 },
  { element: 'Xe', orbital: '4d3/2', be: 63 },
  { element: 'Cs', orbital: '4d3/2', be: 79 },
  { element: 'Ba', orbital: '4d3/2', be: 93 },
  { element: 'La', orbital: '4d3/2', be: 99 },
  { element: 'Ce', orbital: '4d3/2', be: 111 },
  { element: 'Pr', orbital: '4d3/2', be: 114 },
  { element: 'Nd', orbital: '4d3/2', be: 118 },
  { element: 'Pm', orbital: '4d3/2', be: 121 },
  { element: 'Sm', orbital: '4d3/2', be: 130 },
  { element: 'Eu', orbital: '4d3/2', be: 134 },
  { element: 'Gd', orbital: '4d3/2', be: 141 },
  { element: 'Tb', orbital: '4d3/2', be: 148 },
  { element: 'Dy', orbital: '4d3/2', be: 154 },
  { element: 'Ho', orbital: '4d3/2', be: 161 },
  { element: 'Er', orbital: '4d3/2', be: 177 },
  { element: 'Tm', orbital: '4d3/2', be: 180 },
  { element: 'Yb', orbital: '4d3/2', be: 197 },
  { element: 'Lu', orbital: '4d3/2', be: 205 },
  { element: 'Hf', orbital: '4d3/2', be: 224 },
  { element: 'Ta', orbital: '4d3/2', be: 242 },
  { element: 'W', orbital: '4d3/2', be: 259 },
  { element: 'Re', orbital: '4d3/2', be: 274 },
  { element: 'Os', orbital: '4d3/2', be: 290 },
  { element: 'Ir', orbital: '4d3/2', be: 312 },
  { element: 'Pt', orbital: '4d3/2', be: 331 },
  { element: 'Au', orbital: '4d3/2', be: 352 },
  { element: 'Hg', orbital: '4d3/2', be: 379 },
  { element: 'Tl', orbital: '4d3/2', be: 407 },
  { element: 'Pb', orbital: '4d3/2', be: 435 },
  { element: 'Bi', orbital: '4d3/2', be: 464 },
  { element: 'Po', orbital: '4d3/2', be: 500 },
  { element: 'At', orbital: '4d3/2', be: 533 },
  { element: 'Rn', orbital: '4d3/2', be: 567 },
  { element: 'Fr', orbital: '4d3/2', be: 603 },
  { element: 'Ra', orbital: '4d3/2', be: 636 },
  { element: 'Ac', orbital: '4d3/2', be: 675 },
  { element: 'Th', orbital: '4d3/2', be: 714 },
  { element: 'U', orbital: '4d3/2', be: 781 },
  { element: 'Y', orbital: '4d5/2', be: 3 },
  { element: 'Zr', orbital: '4d5/2', be: 3 },
  { element: 'Nb', orbital: '4d5/2', be: 4 },
  { element: 'Mo', orbital: '4d5/2', be: 2 },
  { element: 'Tc', orbital: '4d5/2', be: 2 },
  { element: 'Ru', orbital: '4d5/2', be: 2 },
  { element: 'Rh', orbital: '4d5/2', be: 3 },
  { element: 'Pd', orbital: '4d5/2', be: 1 },
  { element: 'Ag', orbital: '4d5/2', be: 3 },
  { element: 'Cd', orbital: '4d5/2', be: 9 },
  { element: 'In', orbital: '4d5/2', be: 16 },
  { element: 'Sn', orbital: '4d5/2', be: 24 },
  { element: 'Sb', orbital: '4d5/2', be: 32 },
  { element: 'Te', orbital: '4d5/2', be: 40 },
  { element: 'I', orbital: '4d5/2', be: 50 },
  { element: 'Xe', orbital: '4d5/2', be: 63 },
  { element: 'Cs', orbital: '4d5/2', be: 77 },
  { element: 'Ba', orbital: '4d5/2', be: 90 },
  { element: 'La', orbital: '4d5/2', be: 99 },
  { element: 'Ce', orbital: '4d5/2', be: 111 },
  { element: 'Pr', orbital: '4d5/2', be: 114 },
  { element: 'Nd', orbital: '4d5/2', be: 118 },
  { element: 'Pm', orbital: '4d5/2', be: 121 },
  { element: 'Sm', orbital: '4d5/2', be: 130 },
  { element: 'Eu', orbital: '4d5/2', be: 134 },
  { element: 'Gd', orbital: '4d5/2', be: 141 },
  { element: 'Tb', orbital: '4d5/2', be: 148 },
  { element: 'Dy', orbital: '4d5/2', be: 154 },
  { element: 'Ho', orbital: '4d5/2', be: 161 },
  { element: 'Er', orbital: '4d5/2', be: 168 },
  { element: 'Tm', orbital: '4d5/2', be: 180 },
  { element: 'Yb', orbital: '4d5/2', be: 184 },
  { element: 'Lu', orbital: '4d5/2', be: 195 },
  { element: 'Hf', orbital: '4d5/2', be: 214 },
  { element: 'Ta', orbital: '4d5/2', be: 230 },
  { element: 'W', orbital: '4d5/2', be: 246 },
  { element: 'Re', orbital: '4d5/2', be: 260 },
  { element: 'Os', orbital: '4d5/2', be: 273 },
  { element: 'Ir', orbital: '4d5/2', be: 295 },
  { element: 'Pt', orbital: '4d5/2', be: 314 },
  { element: 'Au', orbital: '4d5/2', be: 334 },
  { element: 'Hg', orbital: '4d5/2', be: 360 },
  { element: 'Tl', orbital: '4d5/2', be: 386 },
  { element: 'Pb', orbital: '4d5/2', be: 413 },
  { element: 'Bi', orbital: '4d5/2', be: 440 },
  { element: 'Po', orbital: '4d5/2', be: 473 },
  { element: 'At', orbital: '4d5/2', be: 507 },
  { element: 'Rn', orbital: '4d5/2', be: 541 },
  { element: 'Fr', orbital: '4d5/2', be: 577 },
  { element: 'Ra', orbital: '4d5/2', be: 603 },
  { element: 'Ac', orbital: '4d5/2', be: 639 },
  { element: 'Th', orbital: '4d5/2', be: 677 },
  { element: 'U', orbital: '4d5/2', be: 739 },
  { element: 'Y', orbital: '4d', be: 3 },
  { element: 'Zr', orbital: '4d', be: 3 },
  { element: 'Nb', orbital: '4d', be: 4 },
  { element: 'Mo', orbital: '4d', be: 2 },
  { element: 'Tc', orbital: '4d', be: 2 },
  { element: 'Ru', orbital: '4d', be: 2 },
  { element: 'Rh', orbital: '4d', be: 3 },
  { element: 'Pd', orbital: '4d', be: 1 },
  { element: 'Ag', orbital: '4d', be: 3 },
  { element: 'Cd', orbital: '4d', be: 9 },
  { element: 'In', orbital: '4d', be: 16 },
  { element: 'Sn', orbital: '4d', be: 24 },
  { element: 'Sb', orbital: '4d', be: 32 },
  { element: 'Te', orbital: '4d', be: 40 },
  { element: 'I', orbital: '4d', be: 50 },
  { element: 'Xe', orbital: '4d', be: 63 },
  { element: 'Cs', orbital: '4d', be: 77 },
  { element: 'Ba', orbital: '4d', be: 90 },
  { element: 'La', orbital: '4d', be: 99 },
  { element: 'Ce', orbital: '4d', be: 111 },
  { element: 'Pr', orbital: '4d', be: 114 },
  { element: 'Nd', orbital: '4d', be: 118 },
  { element: 'Pm', orbital: '4d', be: 121 },
  { element: 'Sm', orbital: '4d', be: 130 },
  { element: 'Eu', orbital: '4d', be: 134 },
  { element: 'Gd', orbital: '4d', be: 141 },
  { element: 'Tb', orbital: '4d', be: 148 },
  { element: 'Dy', orbital: '4d', be: 154 },
  { element: 'Ho', orbital: '4d', be: 161 },
  { element: 'Er', orbital: '4d', be: 168 },
  { element: 'Tm', orbital: '4d', be: 180 },
  { element: 'Yb', orbital: '4d', be: 184 },
  { element: 'Lu', orbital: '4d', be: 195 },
  { element: 'Hf', orbital: '4d', be: 214 },
  { element: 'Ta', orbital: '4d', be: 230 },
  { element: 'W', orbital: '4d', be: 246 },
  { element: 'Re', orbital: '4d', be: 260 },
  { element: 'Os', orbital: '4d', be: 273 },
  { element: 'Ir', orbital: '4d', be: 295 },
  { element: 'Pt', orbital: '4d', be: 314 },
  { element: 'Au', orbital: '4d', be: 334 },
  { element: 'Hg', orbital: '4d', be: 360 },
  { element: 'Tl', orbital: '4d', be: 386 },
  { element: 'Pb', orbital: '4d', be: 413 },
  { element: 'Bi', orbital: '4d', be: 440 },
  { element: 'Po', orbital: '4d', be: 473 },
  { element: 'At', orbital: '4d', be: 507 },
  { element: 'Rn', orbital: '4d', be: 541 },
  { element: 'Fr', orbital: '4d', be: 577 },
  { element: 'Ra', orbital: '4d', be: 603 },
  { element: 'Ac', orbital: '4d', be: 639 },
  { element: 'Th', orbital: '4d', be: 677 },
  { element: 'U', orbital: '4d', be: 739 },
  { element: 'Ce', orbital: '4f5/2', be: 1 },
  { element: 'Pr', orbital: '4f5/2', be: 2 },
  { element: 'Nd', orbital: '4f5/2', be: 2 },
  { element: 'Pm', orbital: '4f5/2', be: 4 },
  { element: 'Sm', orbital: '4f5/2', be: 7 },
  { element: 'Tb', orbital: '4f5/2', be: 3 },
  { element: 'Dy', orbital: '4f5/2', be: 4 },
  { element: 'Ho', orbital: '4f5/2', be: 4 },
  { element: 'Er', orbital: '4f5/2', be: 4 },
  { element: 'Tm', orbital: '4f5/2', be: 5 },
  { element: 'Yb', orbital: '4f5/2', be: 6 },
  { element: 'Lu', orbital: '4f5/2', be: 7 },
  { element: 'Hf', orbital: '4f5/2', be: 19 },
  { element: 'Ta', orbital: '4f5/2', be: 27 },
  { element: 'W', orbital: '4f5/2', be: 37 },
  { element: 'Re', orbital: '4f5/2', be: 47 },
  { element: 'Os', orbital: '4f5/2', be: 52 },
  { element: 'Ir', orbital: '4f5/2', be: 63 },
  { element: 'Pt', orbital: '4f5/2', be: 74 },
  { element: 'Au', orbital: '4f5/2', be: 87 },
  { element: 'Hg', orbital: '4f5/2', be: 103 },
  { element: 'Tl', orbital: '4f5/2', be: 122 },
  { element: 'Pb', orbital: '4f5/2', be: 143 },
  { element: 'Bi', orbital: '4f5/2', be: 163 },
  { element: 'Po', orbital: '4f5/2', be: 184 },
  { element: 'At', orbital: '4f5/2', be: 210 },
  { element: 'Rn', orbital: '4f5/2', be: 238 },
  { element: 'Fr', orbital: '4f5/2', be: 268 },
  { element: 'Ra', orbital: '4f5/2', be: 299 },
  { element: 'Ac', orbital: '4f5/2', be: 319 },
  { element: 'Th', orbital: '4f5/2', be: 344 },
  { element: 'U', orbital: '4f5/2', be: 391 },
  { element: 'Ce', orbital: '4f7/2', be: 1 },
  { element: 'Pr', orbital: '4f7/2', be: 2 },
  { element: 'Nd', orbital: '4f7/2', be: 2 },
  { element: 'Pm', orbital: '4f7/2', be: 4 },
  { element: 'Sm', orbital: '4f7/2', be: 7 },
  { element: 'Tb', orbital: '4f7/2', be: 3 },
  { element: 'Dy', orbital: '4f7/2', be: 4 },
  { element: 'Ho', orbital: '4f7/2', be: 4 },
  { element: 'Er', orbital: '4f7/2', be: 4 },
  { element: 'Tm', orbital: '4f7/2', be: 5 },
  { element: 'Yb', orbital: '4f7/2', be: 6 },
  { element: 'Lu', orbital: '4f7/2', be: 7 },
  { element: 'Hf', orbital: '4f7/2', be: 18 },
  { element: 'Ta', orbital: '4f7/2', be: 25 },
  { element: 'W', orbital: '4f7/2', be: 34 },
  { element: 'Re', orbital: '4f7/2', be: 45 },
  { element: 'Os', orbital: '4f7/2', be: 50 },
  { element: 'Ir', orbital: '4f7/2', be: 60 },
  { element: 'Pt', orbital: '4f7/2', be: 70 },
  { element: 'Au', orbital: '4f7/2', be: 83 },
  { element: 'Hg', orbital: '4f7/2', be: 99 },
  { element: 'Tl', orbital: '4f7/2', be: 118 },
  { element: 'Pb', orbital: '4f7/2', be: 138 },
  { element: 'Bi', orbital: '4f7/2', be: 158 },
  { element: 'Po', orbital: '4f7/2', be: 184 },
  { element: 'At', orbital: '4f7/2', be: 210 },
  { element: 'Rn', orbital: '4f7/2', be: 238 },
  { element: 'Fr', orbital: '4f7/2', be: 268 },
  { element: 'Ra', orbital: '4f7/2', be: 299 },
  { element: 'Ac', orbital: '4f7/2', be: 319 },
  { element: 'Th', orbital: '4f7/2', be: 335 },
  { element: 'U', orbital: '4f7/2', be: 380 },
  { element: 'Ce', orbital: '4f', be: 1 },
  { element: 'Pr', orbital: '4f', be: 2 },
  { element: 'Nd', orbital: '4f', be: 2 },
  { element: 'Pm', orbital: '4f', be: 4 },
  { element: 'Sm', orbital: '4f', be: 7 },
  { element: 'Tb', orbital: '4f', be: 3 },
  { element: 'Dy', orbital: '4f', be: 4 },
  { element: 'Ho', orbital: '4f', be: 4 },
  { element: 'Er', orbital: '4f', be: 4 },
  { element: 'Tm', orbital: '4f', be: 5 },
  { element: 'Yb', orbital: '4f', be: 6 },
  { element: 'Lu', orbital: '4f', be: 7 },
  { element: 'Hf', orbital: '4f', be: 18 },
  { element: 'Ta', orbital: '4f', be: 25 },
  { element: 'W', orbital: '4f', be: 34 },
  { element: 'Re', orbital: '4f', be: 45 },
  { element: 'Os', orbital: '4f', be: 50 },
  { element: 'Ir', orbital: '4f', be: 60 },
  { element: 'Pt', orbital: '4f', be: 70 },
  { element: 'Au', orbital: '4f', be: 83 },
  { element: 'Hg', orbital: '4f', be: 99 },
  { element: 'Tl', orbital: '4f', be: 118 },
  { element: 'Pb', orbital: '4f', be: 138 },
  { element: 'Bi', orbital: '4f', be: 158 },
  { element: 'Po', orbital: '4f', be: 184 },
  { element: 'At', orbital: '4f', be: 210 },
  { element: 'Rn', orbital: '4f', be: 238 },
  { element: 'Fr', orbital: '4f', be: 268 },
  { element: 'Ra', orbital: '4f', be: 299 },
  { element: 'Ac', orbital: '4f', be: 319 },
  { element: 'Th', orbital: '4f', be: 335 },
  { element: 'U', orbital: '4f', be: 380 },
  { element: 'Sn', orbital: '5s', be: 1 },
  { element: 'Sb', orbital: '5s', be: 7 },
  { element: 'Te', orbital: '5s', be: 12 },
  { element: 'I', orbital: '5s', be: 14 },
  { element: 'Xe', orbital: '5s', be: 18 },
  { element: 'Cs', orbital: '5s', be: 23 },
  { element: 'Ba', orbital: '5s', be: 40 },
  { element: 'La', orbital: '5s', be: 33 },
  { element: 'Ce', orbital: '5s', be: 38 },
  { element: 'Pr', orbital: '5s', be: 38 },
  { element: 'Nd', orbital: '5s', be: 38 },
  { element: 'Pm', orbital: '5s', be: 38 },
  { element: 'Sm', orbital: '5s', be: 39 },
  { element: 'Eu', orbital: '5s', be: 32 },
  { element: 'Gd', orbital: '5s', be: 36 },
  { element: 'Tb', orbital: '5s', be: 40 },
  { element: 'Dy', orbital: '5s', be: 63 },
  { element: 'Ho', orbital: '5s', be: 51 },
  { element: 'Er', orbital: '5s', be: 60 },
  { element: 'Tm', orbital: '5s', be: 53 },
  { element: 'Yb', orbital: '5s', be: 53 },
  { element: 'Lu', orbital: '5s', be: 57 },
  { element: 'Hf', orbital: '5s', be: 65 },
  { element: 'Ta', orbital: '5s', be: 71 },
  { element: 'W', orbital: '5s', be: 77 },
  { element: 'Re', orbital: '5s', be: 83 },
  { element: 'Os', orbital: '5s', be: 84 },
  { element: 'Ir', orbital: '5s', be: 96 },
  { element: 'Pt', orbital: '5s', be: 102 },
  { element: 'Au', orbital: '5s', be: 108 },
  { element: 'Hg', orbital: '5s', be: 120 },
  { element: 'Tl', orbital: '5s', be: 137 },
  { element: 'Pb', orbital: '5s', be: 148 },
  { element: 'Bi', orbital: '5s', be: 160 },
  { element: 'Po', orbital: '5s', be: 177 },
  { element: 'At', orbital: '5s', be: 195 },
  { element: 'Rn', orbital: '5s', be: 214 },
  { element: 'Fr', orbital: '5s', be: 234 },
  { element: 'Ra', orbital: '5s', be: 254 },
  { element: 'Ac', orbital: '5s', be: 272 },
  { element: 'Th', orbital: '5s', be: 290 },
  { element: 'In', orbital: '5p1/2', be: 1 },
  { element: 'Sn', orbital: '5p1/2', be: 1 },
  { element: 'Sb', orbital: '5p1/2', be: 2 },
  { element: 'Te', orbital: '5p1/2', be: 2 },
  { element: 'I', orbital: '5p1/2', be: 3 },
  { element: 'Xe', orbital: '5p1/2', be: 7 },
  { element: 'Cs', orbital: '5p1/2', be: 13 },
  { element: 'Ba', orbital: '5p1/2', be: 17 },
  { element: 'La', orbital: '5p1/2', be: 15 },
  { element: 'Ce', orbital: '5p1/2', be: 20 },
  { element: 'Pr', orbital: '5p1/2', be: 23 },
  { element: 'Nd', orbital: '5p1/2', be: 22 },
  { element: 'Pm', orbital: '5p1/2', be: 22 },
  { element: 'Sm', orbital: '5p1/2', be: 22 },
  { element: 'Eu', orbital: '5p1/2', be: 22 },
  { element: 'Gd', orbital: '5p1/2', be: 21 },
  { element: 'Tb', orbital: '5p1/2', be: 26 },
  { element: 'Dy', orbital: '5p1/2', be: 26 },
  { element: 'Ho', orbital: '5p1/2', be: 20 },
  { element: 'Er', orbital: '5p1/2', be: 29 },
  { element: 'Tm', orbital: '5p1/2', be: 32 },
  { element: 'Yb', orbital: '5p1/2', be: 23 },
  { element: 'Lu', orbital: '5p1/2', be: 28 },
  { element: 'Hf', orbital: '5p1/2', be: 38 },
  { element: 'Ta', orbital: '5p1/2', be: 45 },
  { element: 'W', orbital: '5p1/2', be: 47 },
  { element: 'Re', orbital: '5p1/2', be: 46 },
  { element: 'Os', orbital: '5p1/2', be: 58 },
  { element: 'Ir', orbital: '5p1/2', be: 63 },
  { element: 'Pt', orbital: '5p1/2', be: 66 },
  { element: 'Au', orbital: '5p1/2', be: 72 },
  { element: 'Hg', orbital: '5p1/2', be: 81 },
  { element: 'Tl', orbital: '5p1/2', be: 100 },
  { element: 'Pb', orbital: '5p1/2', be: 105 },
  { element: 'Bi', orbital: '5p1/2', be: 117 },
  { element: 'Po', orbital: '5p1/2', be: 132 },
  { element: 'At', orbital: '5p1/2', be: 148 },
  { element: 'Rn', orbital: '5p1/2', be: 164 },
  { element: 'Fr', orbital: '5p1/2', be: 182 },
  { element: 'Ra', orbital: '5p1/2', be: 200 },
  { element: 'Ac', orbital: '5p1/2', be: 215 },
  { element: 'Th', orbital: '5p1/2', be: 229 },
  { element: 'In', orbital: '5p3/2', be: 1 },
  { element: 'Sn', orbital: '5p3/2', be: 1 },
  { element: 'Sb', orbital: '5p3/2', be: 2 },
  { element: 'Te', orbital: '5p3/2', be: 2 },
  { element: 'I', orbital: '5p3/2', be: 3 },
  { element: 'Xe', orbital: '5p3/2', be: 7 },
  { element: 'Cs', orbital: '5p3/2', be: 12 },
  { element: 'Ba', orbital: '5p3/2', be: 15 },
  { element: 'La', orbital: '5p3/2', be: 15 },
  { element: 'Ce', orbital: '5p3/2', be: 20 },
  { element: 'Pr', orbital: '5p3/2', be: 23 },
  { element: 'Nd', orbital: '5p3/2', be: 22 },
  { element: 'Pm', orbital: '5p3/2', be: 22 },
  { element: 'Sm', orbital: '5p3/2', be: 22 },
  { element: 'Eu', orbital: '5p3/2', be: 22 },
  { element: 'Gd', orbital: '5p3/2', be: 21 },
  { element: 'Tb', orbital: '5p3/2', be: 26 },
  { element: 'Dy', orbital: '5p3/2', be: 26 },
  { element: 'Ho', orbital: '5p3/2', be: 20 },
  { element: 'Er', orbital: '5p3/2', be: 29 },
  { element: 'Tm', orbital: '5p3/2', be: 32 },
  { element: 'Yb', orbital: '5p3/2', be: 23 },
  { element: 'Lu', orbital: '5p3/2', be: 28 },
  { element: 'Hf', orbital: '5p3/2', be: 31 },
  { element: 'Ta', orbital: '5p3/2', be: 37 },
  { element: 'W', orbital: '5p3/2', be: 37 },
  { element: 'Re', orbital: '5p3/2', be: 35 },
  { element: 'Os', orbital: '5p3/2', be: 46 },
  { element: 'Ir', orbital: '5p3/2', be: 51 },
  { element: 'Pt', orbital: '5p3/2', be: 51 },
  { element: 'Au', orbital: '5p3/2', be: 54 },
  { element: 'Hg', orbital: '5p3/2', be: 58 },
  { element: 'Tl', orbital: '5p3/2', be: 76 },
  { element: 'Pb', orbital: '5p3/2', be: 86 },
  { element: 'Bi', orbital: '5p3/2', be: 93 },
  { element: 'Po', orbital: '5p3/2', be: 104 },
  { element: 'At', orbital: '5p3/2', be: 115 },
  { element: 'Rn', orbital: '5p3/2', be: 127 },
  { element: 'Fr', orbital: '5p3/2', be: 140 },
  { element: 'Ra', orbital: '5p3/2', be: 153 },
  { element: 'Ac', orbital: '5p3/2', be: 167 },
  { element: 'Th', orbital: '5p3/2', be: 182 },
  { element: 'In', orbital: '5p', be: 1 },
  { element: 'Sn', orbital: '5p', be: 1 },
  { element: 'Sb', orbital: '5p', be: 2 },
  { element: 'Te', orbital: '5p', be: 2 },
  { element: 'I', orbital: '5p', be: 3 },
  { element: 'Xe', orbital: '5p', be: 7 },
  { element: 'Cs', orbital: '5p', be: 12 },
  { element: 'Ba', orbital: '5p', be: 15 },
  { element: 'La', orbital: '5p', be: 15 },
  { element: 'Ce', orbital: '5p', be: 20 },
  { element: 'Pr', orbital: '5p', be: 23 },
  { element: 'Nd', orbital: '5p', be: 22 },
  { element: 'Pm', orbital: '5p', be: 22 },
  { element: 'Sm', orbital: '5p', be: 22 },
  { element: 'Eu', orbital: '5p', be: 22 },
  { element: 'Gd', orbital: '5p', be: 21 },
  { element: 'Tb', orbital: '5p', be: 26 },
  { element: 'Dy', orbital: '5p', be: 26 },
  { element: 'Ho', orbital: '5p', be: 20 },
  { element: 'Er', orbital: '5p', be: 29 },
  { element: 'Tm', orbital: '5p', be: 32 },
  { element: 'Yb', orbital: '5p', be: 23 },
  { element: 'Lu', orbital: '5p', be: 28 },
  { element: 'Hf', orbital: '5p', be: 31 },
  { element: 'Ta', orbital: '5p', be: 37 },
  { element: 'W', orbital: '5p', be: 37 },
  { element: 'Re', orbital: '5p', be: 35 },
  { element: 'Os', orbital: '5p', be: 46 },
  { element: 'Ir', orbital: '5p', be: 51 },
  { element: 'Pt', orbital: '5p', be: 51 },
  { element: 'Au', orbital: '5p', be: 54 },
  { element: 'Hg', orbital: '5p', be: 58 },
  { element: 'Tl', orbital: '5p', be: 76 },
  { element: 'Pb', orbital: '5p', be: 86 },
  { element: 'Bi', orbital: '5p', be: 93 },
  { element: 'Po', orbital: '5p', be: 104 },
  { element: 'At', orbital: '5p', be: 115 },
  { element: 'Rn', orbital: '5p', be: 127 },
  { element: 'Fr', orbital: '5p', be: 140 },
  { element: 'Ra', orbital: '5p', be: 153 },
  { element: 'Ac', orbital: '5p', be: 167 },
  { element: 'Th', orbital: '5p', be: 182 },
  { element: 'Lu', orbital: '5d3/2', be: 5 },
  { element: 'Hf', orbital: '5d3/2', be: 7 },
  { element: 'Ta', orbital: '5d3/2', be: 6 },
  { element: 'W', orbital: '5d3/2', be: 6 },
  { element: 'Re', orbital: '5d3/2', be: 4 },
  { element: 'Ir', orbital: '5d3/2', be: 4 },
  { element: 'Pt', orbital: '5d3/2', be: 2 },
  { element: 'Au', orbital: '5d3/2', be: 3 },
  { element: 'Hg', orbital: '5d3/2', be: 7 },
  { element: 'Tl', orbital: '5d3/2', be: 16 },
  { element: 'Pb', orbital: '5d3/2', be: 22 },
  { element: 'Bi', orbital: '5d3/2', be: 27 },
  { element: 'Po', orbital: '5d3/2', be: 31 },
  { element: 'At', orbital: '5d3/2', be: 40 },
  { element: 'Rn', orbital: '5d3/2', be: 48 },
  { element: 'Fr', orbital: '5d3/2', be: 58 },
  { element: 'Ra', orbital: '5d3/2', be: 68 },
  { element: 'Ac', orbital: '5d3/2', be: 80 },
  { element: 'Th', orbital: '5d3/2', be: 95 },
  { element: 'U', orbital: '5d3/2', be: 104 },
  { element: 'Lu', orbital: '5d5/2', be: 5 },
  { element: 'Hf', orbital: '5d5/2', be: 7 },
  { element: 'Ta', orbital: '5d5/2', be: 6 },
  { element: 'W', orbital: '5d5/2', be: 6 },
  { element: 'Re', orbital: '5d5/2', be: 4 },
  { element: 'Ir', orbital: '5d5/2', be: 4 },
  { element: 'Pt', orbital: '5d5/2', be: 2 },
  { element: 'Au', orbital: '5d5/2', be: 3 },
  { element: 'Hg', orbital: '5d5/2', be: 7 },
  { element: 'Tl', orbital: '5d5/2', be: 13 },
  { element: 'Pb', orbital: '5d5/2', be: 20 },
  { element: 'Bi', orbital: '5d5/2', be: 25 },
  { element: 'Po', orbital: '5d5/2', be: 31 },
  { element: 'At', orbital: '5d5/2', be: 40 },
  { element: 'Rn', orbital: '5d5/2', be: 48 },
  { element: 'Fr', orbital: '5d5/2', be: 58 },
  { element: 'Ra', orbital: '5d5/2', be: 68 },
  { element: 'Ac', orbital: '5d5/2', be: 80 },
  { element: 'Th', orbital: '5d5/2', be: 88 },
  { element: 'U', orbital: '5d5/2', be: 96 },
  { element: 'Lu', orbital: '5d', be: 5 },
  { element: 'Hf', orbital: '5d', be: 7 },
  { element: 'Ta', orbital: '5d', be: 6 },
  { element: 'W', orbital: '5d', be: 6 },
  { element: 'Re', orbital: '5d', be: 4 },
  { element: 'Ir', orbital: '5d', be: 4 },
  { element: 'Pt', orbital: '5d', be: 2 },
  { element: 'Au', orbital: '5d', be: 3 },
  { element: 'Hg', orbital: '5d', be: 7 },
  { element: 'Tl', orbital: '5d', be: 13 },
  { element: 'Pb', orbital: '5d', be: 20 },
  { element: 'Bi', orbital: '5d', be: 25 },
  { element: 'Po', orbital: '5d', be: 31 },
  { element: 'At', orbital: '5d', be: 40 },
  { element: 'Rn', orbital: '5d', be: 48 },
  { element: 'Fr', orbital: '5d', be: 58 },
  { element: 'Ra', orbital: '5d', be: 68 },
  { element: 'Ac', orbital: '5d', be: 80 },
  { element: 'Th', orbital: '5d', be: 88 },
  { element: 'U', orbital: '5d', be: 96 },
  { element: 'Pb', orbital: '6s', be: 3 },
  { element: 'Bi', orbital: '6s', be: 8 },
  { element: 'Po', orbital: '6s', be: 12 },
  { element: 'At', orbital: '6s', be: 18 },
  { element: 'Rn', orbital: '6s', be: 26 },
  { element: 'Fr', orbital: '6s', be: 34 },
  { element: 'Ra', orbital: '6s', be: 44 },
  { element: 'Th', orbital: '6s', be: 60 },
  { element: 'Pb', orbital: '6p1/2', be: 1 },
  { element: 'Bi', orbital: '6p1/2', be: 3 },
  { element: 'Po', orbital: '6p1/2', be: 5 },
  { element: 'At', orbital: '6p1/2', be: 8 },
  { element: 'Rn', orbital: '6p1/2', be: 11 },
  { element: 'Fr', orbital: '6p1/2', be: 15 },
  { element: 'Ra', orbital: '6p1/2', be: 19 },
  { element: 'Th', orbital: '6p1/2', be: 49 },
  { element: 'U', orbital: '6p1/2', be: 28.9 },
  { element: 'Pb', orbital: '6p3/2', be: 1 },
  { element: 'Bi', orbital: '6p3/2', be: 3 },
  { element: 'Po', orbital: '6p3/2', be: 5 },
  { element: 'At', orbital: '6p3/2', be: 8 },
  { element: 'Rn', orbital: '6p3/2', be: 11 },
  { element: 'Fr', orbital: '6p3/2', be: 15 },
  { element: 'Ra', orbital: '6p3/2', be: 19 },
  { element: 'Th', orbital: '6p3/2', be: 43 },
  { element: 'U', orbital: '6p3/2', be: 19 },
  { element: 'Pb', orbital: '6p', be: 1 },
  { element: 'Bi', orbital: '6p', be: 3 },
  { element: 'Po', orbital: '6p', be: 5 },
  { element: 'At', orbital: '6p', be: 8 },
  { element: 'Rn', orbital: '6p', be: 11 },
  { element: 'Fr', orbital: '6p', be: 15 },
  { element: 'Ra', orbital: '6p', be: 19 },
  { element: 'Th', orbital: '6p', be: 43 },
  { element: 'U', orbital: '6p', be: 19 },
];
